/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "catalog/models.proto" (package "rd.catalog", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Visibility } from "../search/cache/visibility/models_pb";
import { IntegrationVendor } from "../proto/integration_vendor/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { Money } from "../proto/money/models_pb";
import { FractionalMoney } from "../proto/money/models_pb";
/**
 * DiscontinuedStatus tracks the discontinued state for a substitute item
 *
 * @generated from protobuf message rd.catalog.DiscontinuedStatus
 */
export interface DiscontinuedStatus {
    /**
     * @generated from protobuf field: bool discontinued = 1
     */
    discontinued: boolean;
    /**
     * @generated from protobuf field: bool to_be_discontinued = 2
     */
    toBeDiscontinued: boolean;
}
/**
 * SubstituteInfo contains a vendor-agnostic alternative product for a discontinued item
 *
 * @generated from protobuf message rd.catalog.SubstituteInfo
 */
export interface SubstituteInfo {
    /**
     * @generated from protobuf field: string alternative_sku = 1
     */
    alternativeSku: string;
    /**
     * @generated from protobuf field: rd.catalog.SubstituteInfo.AlternativeType type = 2
     */
    type: SubstituteInfo_AlternativeType;
}
/**
 * @generated from protobuf enum rd.catalog.SubstituteInfo.AlternativeType
 */
export enum SubstituteInfo_AlternativeType {
    /**
     * @generated from protobuf enum value: ALTERNATIVE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ALTERNATIVE_TYPE_SUBSTITUTE = 1;
     */
    SUBSTITUTE = 1,
    /**
     * @generated from protobuf enum value: ALTERNATIVE_TYPE_REFERRAL = 2;
     */
    REFERRAL = 2
}
/**
 * For EDI Cost Items
 *
 * @generated from protobuf message rd.catalog.CostLineItem
 */
export interface CostLineItem {
    /**
     * @generated from protobuf field: rd.catalog.CostLineItem.Severity severity = 1
     */
    severity: CostLineItem_Severity;
    /**
     * @generated from protobuf field: string label = 2
     */
    label: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 3
     */
    cost?: FractionalMoney;
}
/**
 * @generated from protobuf enum rd.catalog.CostLineItem.Severity
 */
export enum CostLineItem_Severity {
    /**
     * @generated from protobuf enum value: SEVERITY_UNSPECIFIED = 0;
     */
    SEVERITY_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WARN = 1;
     */
    WARN = 1
}
/**
 * For EDI Ordering
 *
 * @generated from protobuf message rd.catalog.OrderSuggestion
 */
export interface OrderSuggestion {
    /**
     * @generated from protobuf field: rd.catalog.OrderSuggestion.Type type = 1
     */
    type: OrderSuggestion_Type;
    /**
     * @generated from protobuf field: rd.catalog.OrderSuggestion.Severity severity = 2
     */
    severity: OrderSuggestion_Severity;
    /**
     * @generated from protobuf field: string message = 3
     */
    message: string;
    /**
     * @generated from protobuf field: string button_message = 4
     */
    buttonMessage: string;
    /**
     * @generated from protobuf field: int32 updated_quantity = 5
     */
    updatedQuantity: number;
}
/**
 * @generated from protobuf enum rd.catalog.OrderSuggestion.Type
 */
export enum OrderSuggestion_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    TYPE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: QUANTITY_CHANGE = 1;
     */
    QUANTITY_CHANGE = 1,
    /**
     * @generated from protobuf enum value: REMOVE_PRODUCT = 2;
     */
    REMOVE_PRODUCT = 2
}
/**
 * @generated from protobuf enum rd.catalog.OrderSuggestion.Severity
 */
export enum OrderSuggestion_Severity {
    /**
     * @generated from protobuf enum value: SEVERITY_UNSPECIFIED = 0;
     */
    SEVERITY_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WARN = 1;
     */
    WARN = 1,
    /**
     * @generated from protobuf enum value: INFO = 2;
     */
    INFO = 2,
    /**
     * @generated from protobuf enum value: ERROR = 3;
     */
    ERROR = 3
}
/**
 * ComputedSKUInfo contains vendor-agnostic information computed from vendor-specific catalog items.
 *
 * @generated from protobuf message rd.catalog.ComputedSKUInfo
 */
export interface ComputedSKUInfo {
    /**
     * @generated from protobuf field: rd.catalog.DiscontinuedStatus discontinued_status = 1
     */
    discontinuedStatus?: DiscontinuedStatus;
    /**
     * @generated from protobuf field: rd.catalog.SubstituteInfo substitute_info = 2
     */
    substituteInfo?: SubstituteInfo;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_cost = 3
     */
    unitCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.Money retail_price = 4
     */
    retailPrice?: Money;
    /**
     * @generated from protobuf field: string ordering_uom_label = 5
     */
    orderingUomLabel: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_quantity = 6
     */
    caseQuantity?: Decimal;
    /**
     * @generated from protobuf field: string retail_uom_label = 7
     */
    retailUomLabel: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_uom_conversion_factor = 8
     */
    retailUomConversionFactor?: Decimal;
    /**
     * @generated from protobuf field: optional int32 inventory = 9
     */
    inventory?: number;
}
/**
 * TODO - Rename this to UPC (future migration effort)
 *
 * @generated from protobuf message rd.catalog.Product
 */
export interface Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string upc = 4
     */
    upc: string; // unique
    /**
     * @generated from protobuf field: string name = 5
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_retail = 7
     */
    suggestedRetail?: Money;
    /**
     * @generated from protobuf field: string title_description = 10
     */
    titleDescription: string;
    /**
     * @generated from protobuf field: string long_description = 11
     */
    longDescription: string;
    /**
     * @generated from protobuf field: rd.catalog.Product.Attributes attributes = 13
     */
    attributes?: Product_Attributes;
    /**
     * @generated from protobuf field: repeated rd.catalog.Product.ProductImages image_urls = 14
     */
    imageUrls: Product_ProductImages[]; // we should allow multiple images on a item
    /**
     * @generated from protobuf field: rd.catalog.Product.DescriptionSource long_description_source = 15
     */
    longDescriptionSource: Product_DescriptionSource;
}
/**
 * @generated from protobuf message rd.catalog.Product.Attributes
 */
export interface Product_Attributes {
    /**
     * @generated from protobuf field: string manufacturer = 1
     */
    manufacturer: string;
    /**
     * @generated from protobuf field: string model_number = 2
     */
    modelNumber: string;
    /**
     * @generated from protobuf field: string country_of_origin = 3
     */
    countryOfOrigin: string;
    /**
     * @generated from protobuf field: string hazardous = 4
     */
    hazardous: string;
    /**
     * Physical properties
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal weight = 5
     */
    weight?: Decimal; // weight in pounds
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal length = 6
     */
    length?: Decimal; // length in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal width = 7
     */
    width?: Decimal; // width in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal height = 8
     */
    height?: Decimal; // height in inches
}
/**
 * @generated from protobuf message rd.catalog.Product.ProductImages
 */
export interface Product_ProductImages {
    /**
     * @generated from protobuf field: string original_url_hash = 1
     */
    originalUrlHash: string;
    /**
     * @generated from protobuf field: string rundoo_cdn_url = 2
     */
    rundooCdnUrl: string;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor vendor = 3
     */
    vendor: IntegrationVendor; // optinoal vendor field
}
/**
 * @generated from protobuf enum rd.catalog.Product.DescriptionSource
 */
export enum Product_DescriptionSource {
    /**
     * @generated from protobuf enum value: DESCRIPTION_SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DESCRIPTION_SOURCE_ORGILL = 1;
     */
    ORGILL = 1,
    /**
     * @generated from protobuf enum value: DESCRIPTION_SOURCE_BIG_PRODUCT_DATA = 2;
     */
    BIG_PRODUCT_DATA = 2,
    /**
     * @generated from protobuf enum value: DESCRIPTION_SOURCE_MANUAL = 3;
     */
    MANUAL = 3,
    /**
     * @generated from protobuf enum value: DESCRIPTION_SOURCE_SCRAPED = 4;
     */
    SCRAPED = 4
}
/**
 * Taken directly from this API in an unstructure format:
 * https://rapidapi.com/bigproductdata/api/big-product-data
 *
 * @generated from protobuf message rd.catalog.BigProductData
 */
export interface BigProductData {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string upc = 2
     */
    upc: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string json_payload = 5
     */
    jsonPayload: string;
    /**
     * @generated from protobuf field: int32 http_status_code = 6
     */
    httpStatusCode: number;
}
/**
 * @generated from protobuf message rd.catalog.DoItBestCatalogItem
 */
export interface DoItBestCatalogItem {
    /**
     * Vendor-specific pricing fields
     *
     * @generated from protobuf field: rd.proto.money.Money suggested_retail = 1
     */
    suggestedRetail?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_aux_retail = 2
     */
    suggestedAuxRetail?: Money;
    /**
     * Alternative cost fields (all format 9(5)V999 - 3 decimal places)
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney classic_1_cost = 53
     */
    classic1Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney classic_2_cost = 3
     */
    classic2Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney classic_3_cost = 4
     */
    classic3Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney vision_1_cost = 5
     */
    vision1Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney vision_2_cost = 6
     */
    vision2Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney vision_3_cost = 7
     */
    vision3Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney par_1_cost = 8
     */
    par1Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney par_2_cost = 9
     */
    par2Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney par_3_cost = 10
     */
    par3Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney drop_ship_cost = 11
     */
    dropShipCost?: FractionalMoney;
    /**
     * Margin fields
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal gross_margin = 12
     */
    grossMargin?: Decimal; // Format S99V9 (can be negative)
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal suggested_aux_margin = 13
     */
    suggestedAuxMargin?: Decimal; // Format 99V9
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal suggested_classic_margin = 14
     */
    suggestedClassicMargin?: Decimal; // Format 99V9
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal suggested_vision_margin = 15
     */
    suggestedVisionMargin?: Decimal; // Format 99V9
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal suggested_par_margin = 16
     */
    suggestedParMargin?: Decimal; // Format 99V9
    /**
     * Vendor and classification codes
     *
     * @generated from protobuf field: string rsc_code = 17
     */
    rscCode: string; // Retail Service Center code
    /**
     * @generated from protobuf field: string vendor_number = 18
     */
    vendorNumber: string; // Do it Best vendor number (4 chars)
    /**
     * @generated from protobuf field: string vendor_name = 19
     */
    vendorName: string; // Name of vendor (20 chars)
    /**
     * @generated from protobuf field: rd.catalog.DoItBestDepartment department = 20
     */
    department: DoItBestDepartment; // Department type
    /**
     * @generated from protobuf field: string product_classification_department = 21
     */
    productClassificationDepartment: string; // Product classification (4 chars)
    /**
     * @generated from protobuf field: string product_group = 22
     */
    productGroup: string; // Product group (4 chars)
    /**
     * Order multiples
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal mult_1 = 23
     */
    mult1?: Decimal; // Largest order multiple (case or pallet)
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal mult_2 = 24
     */
    mult2?: Decimal; // Second largest (inner pack)
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal mult_3 = 25
     */
    mult3?: Decimal; // Smallest order multiple
    /**
     * @generated from protobuf field: string case_multiple_code = 26
     */
    caseMultipleCode: string; // 1, 2, or 3 indicating which mult is a case
    /**
     * Units and auxiliary selling info
     *
     * @generated from protobuf field: string aux_unit = 27
     */
    auxUnit: string; // Selling unit of measure
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal aux_quantity = 28
     */
    auxQuantity?: Decimal; // Auxiliary/selling quantity
    /**
     * Physical properties
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal unit_weight = 29
     */
    unitWeight?: Decimal; // Weight in pounds (format 9(4)V999)
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal unit_cube = 30
     */
    unitCube?: Decimal; // Cubic feet (format 999V9999)
    /**
     * Item status and classification
     *
     * @generated from protobuf field: string status_code = 31
     */
    statusCode: string; // Position 328: N=Normal, 1=CWO, 2=TCL, 3=Discontinued, 9=New
    /**
     * @generated from protobuf field: string item_type_switch = 32
     */
    itemTypeSwitch: string; // Position 326: G=Generic, Space=Not new, H=RSC new item
    /**
     * @generated from protobuf field: string new_item_indicator = 33
     */
    newItemIndicator: string; // Position 327: Space or H
    /**
     * @generated from protobuf field: string promo_status_code = 34
     */
    promoStatusCode: string; // Position 329: 6=On sale, Space=Not on sale
    /**
     * Product identifiers
     *
     * @generated from protobuf field: string substitute_item_2 = 35
     */
    substituteItem2: string; // Second substitute item (6 chars)
    /**
     * @generated from protobuf field: string country_of_origin = 36
     */
    countryOfOrigin: string; // ISO country code (3 chars)
    /**
     * @generated from protobuf field: string return_goods_code = 37
     */
    returnGoodsCode: string; // Return policy code
    /**
     * @generated from protobuf field: string price_code = 38
     */
    priceCode: string; // A=Price Sensitive, B=Competitive, C=Non-Competitive, D=Blind
    /**
     * @generated from protobuf field: string product_code_pkg_switch = 39
     */
    productCodePkgSwitch: string; // Y=Bar code on package, N=Not on package
    /**
     * Inventory and shipping flags
     *
     * @generated from protobuf field: bool ups_switch = 40
     */
    upsSwitch: boolean; // Can be shipped via UPS
    /**
     * @generated from protobuf field: bool central_stock_switch = 41
     */
    centralStockSwitch: boolean; // Central stock availability
    /**
     * @generated from protobuf field: string cs_primary_rsc = 42
     */
    csPrimaryRsc: string; // Central Stock Primary RSC (2 chars)
    /**
     * @generated from protobuf field: string cs_secondary_rsc = 43
     */
    csSecondaryRsc: string; // Central Stock Secondary RSC (2 chars)
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal exception_quantity = 44
     */
    exceptionQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal maximum_quantity = 45
     */
    maximumQuantity?: Decimal;
    /**
     * @generated from protobuf field: string max_quantity_switch = 46
     */
    maxQuantitySwitch: string; // M=Bill max, O=Bill min order multiple
    /**
     * Private label
     *
     * @generated from protobuf field: bool private_label = 47
     */
    privateLabel: boolean; // Is private label item
    /**
     * @generated from protobuf field: string private_label_description = 48
     */
    privateLabelDescription: string; // Private label description (25 chars)
    /**
     * Timestamps from vendor
     *
     * @generated from protobuf field: google.protobuf.Timestamp load_date = 49
     */
    loadDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 50
     */
    timestamp?: Timestamp;
    // VendorLocationSettings.pricing_tier

    /**
     * Member retail (positions 250-256): format 9(5)V99
     *
     * @generated from protobuf field: rd.proto.money.Money member_retail = 52
     */
    memberRetail?: Money;
    /**
     * @generated from protobuf field: string manufacturer_part_number = 54
     */
    manufacturerPartNumber: string;
    /**
     * @generated from protobuf field: string coupon_code = 55
     */
    couponCode: string;
    /**
     * @generated from protobuf field: string coupon_tax = 56
     */
    couponTax: string;
    /**
     * @generated from protobuf field: string fine_line_class_code = 57
     */
    fineLineClassCode: string;
    /**
     * @generated from protobuf field: string unit = 58
     */
    unit: string;
    /**
     * @generated from protobuf field: string substitute_item = 59
     */
    substituteItem: string;
    /**
     * @generated from protobuf field: string master_image_url = 60
     */
    masterImageUrl: string;
    /**
     * @generated from protobuf field: repeated string other_image_urls = 61
     */
    otherImageUrls: string[];
}
/**
 * @generated from protobuf message rd.catalog.OrgillCatalogItem
 */
export interface OrgillCatalogItem {
    /**
     * @generated from protobuf field: string break_pack_flag = 1
     */
    breakPackFlag: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal weight = 2
     */
    weight?: Decimal;
    /**
     * @generated from protobuf field: string division = 3
     */
    division: string;
    /**
     * Pricing fields
     *
     * @generated from protobuf field: rd.proto.money.Money suggested_retail = 4
     */
    suggestedRetail?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sell_price_1 = 5
     */
    sellPrice1?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney vp1_cost = 6
     */
    vp1Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney vp2_cost = 7
     */
    vp2Cost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney adv_cost = 8
     */
    advCost?: FractionalMoney;
    /**
     * Physical properties
     *
     * @generated from protobuf field: string retail_unit_of_measure = 9
     */
    retailUnitOfMeasure: string;
    /**
     * @generated from protobuf field: string retail_sensitivity_code = 10
     */
    retailSensitivityCode: string;
    /**
     * @generated from protobuf field: string quantity_round_option = 11
     */
    quantityRoundOption: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal factory_pack_size = 12
     */
    factoryPackSize?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money benchmark_pro = 13
     */
    benchmarkPro?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money benchmark_retail = 14
     */
    benchmarkRetail?: Money;
    /**
     * @generated from protobuf field: string ic_master = 15
     */
    icMaster: string;
    /**
     * @generated from protobuf field: string ic_major = 16
     */
    icMajor: string;
    /**
     * @generated from protobuf field: string ic_sub_1 = 17
     */
    icSub1: string;
    /**
     * @generated from protobuf field: string retail_dept_description = 18
     */
    retailDeptDescription: string;
    /**
     * @generated from protobuf field: string retail_class_description = 19
     */
    retailClassDescription: string;
    /**
     * @generated from protobuf field: string country_code = 20
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string retail_sensitivity_code_numeric = 21
     */
    retailSensitivityCodeNumeric: string;
    /**
     * @generated from protobuf field: string harmonized_code = 22
     */
    harmonizedCode: string;
    /**
     * @generated from protobuf field: bool hazardous_air = 23
     */
    hazardousAir: boolean;
    /**
     * @generated from protobuf field: bool hazardous_inland = 24
     */
    hazardousInland: boolean;
    /**
     * @generated from protobuf field: bool hazardous_marine = 25
     */
    hazardousMarine: boolean;
    /**
     * @generated from protobuf field: string ansi_selling_unit_of_measure = 26
     */
    ansiSellingUnitOfMeasure: string;
    /**
     * @generated from protobuf field: string ansi_retail_unit_of_measure = 27
     */
    ansiRetailUnitOfMeasure: string;
    /**
     * @generated from protobuf field: string record_change_flag = 28
     */
    recordChangeFlag: string; // Y=Changed, space=New, A=Add, D=Discontinued
    /**
     * @generated from protobuf field: string velocity_code = 29
     */
    velocityCode: string; // A=Moves quickly, N=Don't Run Out, D=Discontinued
    /**
     * Additional raw fixed-width Orgill fields
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal minimum_order_quantity = 30
     */
    minimumOrderQuantity?: Decimal;
    /**
     * @generated from protobuf field: string buying_department = 31
     */
    buyingDepartment: string;
    /**
     * @generated from protobuf field: string report_group = 32
     */
    reportGroup: string;
    /**
     * @generated from protobuf field: string selling_unit_of_measure = 33
     */
    sellingUnitOfMeasure: string;
    /**
     * @generated from protobuf field: string retail_classification = 34
     */
    retailClassification: string;
    /**
     * @generated from protobuf field: string vendor_number = 35
     */
    vendorNumber: string;
    /**
     * @generated from protobuf field: string factory_number = 36
     */
    factoryNumber: string;
    /**
     * @generated from protobuf field: string retail_conversion_flag = 37
     */
    retailConversionFlag: string; // M=Multiply, D=Divide
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_conversion_factor = 38
     */
    retailConversionFactor?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal shelf_pack = 39
     */
    shelfPack?: Decimal;
    /**
     * @generated from protobuf field: string retail_unit_of_measure_extended = 40
     */
    retailUnitOfMeasureExtended: string; // Position 366-370
    /**
     * @generated from protobuf field: string pro_sensitivity_code = 41
     */
    proSensitivityCode: string;
    /**
     * Substitute/referral from discontinued products file
     *
     * @generated from protobuf field: string substitute_number = 42
     */
    substituteNumber: string;
    /**
     * @generated from protobuf field: string referral_number = 43
     */
    referralNumber: string;
    /**
     * Cloudinary image URLs generated from Orgill image service.
     *
     * @generated from protobuf field: string large_image_url = 44
     */
    largeImageUrl: string;
    /**
     * @generated from protobuf field: string small_image_url = 45
     */
    smallImageUrl: string;
    /**
     * Fields from per-DC Standard Data File (Orgill-Standard-Data-File-DC-XXX.xlsx)
     *
     * @generated from protobuf field: string vendor_name = 46
     */
    vendorName: string;
    /**
     * @generated from protobuf field: string model_number = 47
     */
    modelNumber: string;
    /**
     * @generated from protobuf field: string vendor_unit_of_measure = 48
     */
    vendorUnitOfMeasure: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal selling_unit_pack_size = 49
     */
    sellingUnitPackSize?: Decimal;
    /**
     * @generated from protobuf field: string container_upc = 50
     */
    containerUpc: string;
    /**
     * @generated from protobuf field: string old_upc = 51
     */
    oldUpc: string;
    /**
     * @generated from protobuf field: string online_title_description = 52
     */
    onlineTitleDescription: string;
    /**
     * @generated from protobuf field: string online_long_description = 53
     */
    onlineLongDescription: string;
    /**
     * @generated from protobuf field: string major_category_name = 54
     */
    majorCategoryName: string;
    /**
     * @generated from protobuf field: string master_category_name = 55
     */
    masterCategoryName: string;
}
/**
 * @generated from protobuf message rd.catalog.TrueValueCatalogItem
 */
export interface TrueValueCatalogItem {
    /**
     * true value tier costs
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney member_cost_tier_1 = 52
     */
    memberCostTier1?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tier_1_quantity = 53
     */
    tier1Quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney member_cost_tier_2 = 1
     */
    memberCostTier2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tier_2_quantity = 2
     */
    tier2Quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney member_cost_tier_3 = 3
     */
    memberCostTier3?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tier_3_quantity = 4
     */
    tier3Quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney member_cost_tier_4 = 5
     */
    memberCostTier4?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tier_4_quantity = 6
     */
    tier4Quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_retail_price = 54
     */
    suggestedRetailPrice?: Money;
    /**
     * @generated from protobuf field: string model_number = 55
     */
    modelNumber: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal multiplier = 58
     */
    multiplier?: Decimal; // Number of smallest retail saleable units (for dual-UOM items)
    /**
     * true value variable pricing
     *
     * @generated from protobuf field: rd.proto.money.Money variable_retail_price = 7
     */
    variableRetailPrice?: Money;
    /**
     * @generated from protobuf field: string variable_price_method_code = 8
     */
    variablePriceMethodCode: string; // A-J, O, T, or blank
    /**
     * @generated from protobuf field: rd.proto.money.Money wholesale_variable_retail_price = 9
     */
    wholesaleVariableRetailPrice?: Money;
    /**
     * @generated from protobuf field: string wholesale_variable_price_uom = 10
     */
    wholesaleVariablePriceUom: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money fractional_variable_retail_price = 11
     */
    fractionalVariableRetailPrice?: Money;
    /**
     * @generated from protobuf field: string fractional_variable_price_uom = 12
     */
    fractionalVariablePriceUom: string;
    /**
     * true value wholesale pricing
     *
     * @generated from protobuf field: rd.proto.money.Money wholesale_suggested_retail = 13
     */
    wholesaleSuggestedRetail?: Money;
    /**
     * @generated from protobuf field: string wholesale_sr_uom = 14
     */
    wholesaleSrUom: string;
    /**
     * true value classification codes
     *
     * @generated from protobuf field: string vendor_name = 15
     */
    vendorName: string; // Manufacturer name (field C)
    /**
     * @generated from protobuf field: string buy_dept = 16
     */
    buyDept: string; // True Value wholesale buying department
    /**
     * @generated from protobuf field: string fineline_dept = 17
     */
    finelineDept: string; // Retail Fine Line Department Code
    /**
     * @generated from protobuf field: string fineline_class = 56
     */
    finelineClass: string; // Retail Fine Line Class Code
    /**
     * @generated from protobuf field: string fineline_subclass = 18
     */
    finelineSubclass: string; // Retail Fine Line Subclass Code
    /**
     * @generated from protobuf field: string retail_page = 19
     */
    retailPage: string; // Publishing Fine Line Catalog Page
    /**
     * @generated from protobuf field: string exclusive_brand_code = 20
     */
    exclusiveBrandCode: string; // e.g., '04'=Affiliates
    /**
     * true value flags (categorization and attributes)
     *
     * @generated from protobuf field: string planogram = 21
     */
    planogram: string; // '4'=Basic item, '2'=Expanded item
    /**
     * @generated from protobuf field: string policy_a = 22
     */
    policyA: string; // '1'=Policy A coverage, empty=not covered
    /**
     * @generated from protobuf field: string dated_merch = 23
     */
    datedMerch: string; // '1'=Dated merchandise, empty=not dated
    /**
     * @generated from protobuf field: string retail_assortment_code = 24
     */
    retailAssortmentCode: string; // 1=Basic, 2=Expanded, 3=Dominant, 4=Other DTV
    /**
     * @generated from protobuf field: string core_indicator = 25
     */
    coreIndicator: string; // 'Y'=Core Item, 'N'=Not a Core Item
    /**
     * @generated from protobuf field: string green_item = 26
     */
    greenItem: string; // 'Y'=Green Item, 'N'=Not a Green Item
    /**
     * @generated from protobuf field: string tiered_item = 27
     */
    tieredItem: string; // 'T'=Item is tiered, empty=not tiered
    /**
     * @generated from protobuf field: string visibility_flag_edlp = 28
     */
    visibilityFlagEdlp: string; // 'H'=EDLP, 'V'=Visible, empty=Blind
    /**
     * @generated from protobuf field: string made_in_usa = 29
     */
    madeInUsa: string; // 'Y'=Made in USA, 'N'=Not made in USA
    /**
     * true value inventory/shipping flags
     *
     * @generated from protobuf field: string central_ship_indicator = 30
     */
    centralShipIndicator: string; // '1'=Ships from central location, empty=ships from RDC
    /**
     * @generated from protobuf field: string non_stocked_sku = 31
     */
    nonStockedSku: string; // 'Y'=Not stocked in True Value RDC, empty=stocked
    /**
     * @generated from protobuf field: string break_pack = 32
     */
    breakPack: string; // 'F'=Full pack quantities only, empty=break pack available
    /**
     * @generated from protobuf field: string broken_carton_chrg = 57
     */
    brokenCartonChrg: string; // '1'=Broken carton charges apply, empty=no charge
    /**
     * true value physical dimensions
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal weight = 33
     */
    weight?: Decimal; // Item weight in pounds
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal length = 34
     */
    length?: Decimal; // Item length in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal width = 35
     */
    width?: Decimal; // Item width in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal height = 36
     */
    height?: Decimal; // Item height in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal shelf_weight = 37
     */
    shelfWeight?: Decimal; // Shelf weight in pounds
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal shelf_length = 38
     */
    shelfLength?: Decimal; // Shelf length in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal shelf_width = 39
     */
    shelfWidth?: Decimal; // Shelf width in inches
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal shelf_height = 40
     */
    shelfHeight?: Decimal; // Shelf height in inches
    /**
     * true value marketing/promotion
     *
     * @generated from protobuf field: string coupon_source = 41
     */
    couponSource: string; // 'TVR'=True Value Rewards, 'TDM'=Targeted Direct, 'NTL'=National Adv
    /**
     * @generated from protobuf field: string coupon_type = 42
     */
    couponType: string; // 'D'=Dollar Amount, 'P'=Percent Off, 'F'=Free Product
    /**
     * @generated from protobuf field: string image_id = 43
     */
    imageId: string; // True Value assigned image code
    /**
     * true value dates (lifecycle tracking)
     *
     * @generated from protobuf field: google.protobuf.Timestamp to_be_discontinued_date = 44
     */
    toBeDiscontinuedDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp discontinued_date = 45
     */
    discontinuedDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date_added = 46
     */
    dateAdded?: Timestamp;
    /**
     * true value discontinued flags
     * - ToBeDiscontinuedFlag: 'D' indicates item to be discontinued
     * - DiscontinuedFlag: '1' indicates this item has been discontinued
     *
     * @generated from protobuf field: string to_be_discontinued_flag = 50
     */
    toBeDiscontinuedFlag: string;
    /**
     * @generated from protobuf field: string discontinued_flag = 51
     */
    discontinuedFlag: string;
    /**
     * true value additional codes
     *
     * @generated from protobuf field: string substitute_item_type_code = 47
     */
    substituteItemTypeCode: string; // 1=sub when OOS, 2=sub immediately, 3=referral only
    /**
     * @generated from protobuf field: string discontinue_reason_code = 48
     */
    discontinueReasonCode: string; // A-J (reason for discontinuation)
    /**
     * @generated from protobuf field: string update_indicator = 49
     */
    updateIndicator: string; // 'X' indicates update
    /**
     * Raw substitute/referral item number from vendor feed
     *
     * @generated from protobuf field: string substitute_referral_item_number = 59
     */
    substituteReferralItemNumber: string;
    /**
     * @generated from protobuf field: string retail_uom = 60
     */
    retailUom: string;
}
/**
 * @generated from protobuf message rd.catalog.EmeryJensenCatalogItem
 */
export interface EmeryJensenCatalogItem {
    /**
     * Pricing fields
     *
     * @generated from protobuf field: rd.proto.money.Money ace_retail_amount = 1
     */
    aceRetailAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money regular_retail_amount = 2
     */
    regularRetailAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money level_1_retail_amount = 3
     */
    level1RetailAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money level_2_retail_amount = 4
     */
    level2RetailAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money mru_retail_amount = 5
     */
    mruRetailAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money retail_store_prc = 6
     */
    retailStorePrc?: Money;
    /**
     * Classification and identification
     *
     * @generated from protobuf field: string product_source_code = 7
     */
    productSourceCode: string;
    /**
     * @generated from protobuf field: string rsc_rdc_code = 8
     */
    rscRdcCode: string;
    /**
     * @generated from protobuf field: string com_group = 9
     */
    comGroup: string;
    /**
     * @generated from protobuf field: int32 merchandise_class_number = 10
     */
    merchandiseClassNumber: number;
    /**
     * @generated from protobuf field: string price_strategy_code = 11
     */
    priceStrategyCode: string;
    /**
     * @generated from protobuf field: string product_group_code = 12
     */
    productGroupCode: string;
    /**
     * @generated from protobuf field: string product_def_code = 13
     */
    productDefCode: string;
    /**
     * @generated from protobuf field: string vendor_number = 14
     */
    vendorNumber: string;
    /**
     * @generated from protobuf field: string manufacturer_number = 15
     */
    manufacturerNumber: string;
    /**
     * @generated from protobuf field: string brand_name = 16
     */
    brandName: string;
    /**
     * Order and quantity fields
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal minimum_order_quantity = 17
     */
    minimumOrderQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_units_quantity = 18
     */
    retailUnitsQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_unit_dom_quantity = 19
     */
    retailUnitDomQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal consumer_unit_quantity = 20
     */
    consumerUnitQuantity?: Decimal;
    /**
     * @generated from protobuf field: string consumer_unit_of_measure_code = 21
     */
    consumerUnitOfMeasureCode: string;
    /**
     * Planogram and format flags
     *
     * @generated from protobuf field: string shelf_sequence = 22
     */
    shelfSequence: string;
    /**
     * @generated from protobuf field: string exp_fmt_disc_flag = 23
     */
    expFmtDiscFlag: string;
    /**
     * @generated from protobuf field: string conv_fmt_disc_flag = 24
     */
    convFmtDiscFlag: string;
    /**
     * @generated from protobuf field: string core_fmt_disc_flag = 25
     */
    coreFmtDiscFlag: string;
    /**
     * @generated from protobuf field: string super_fmt_disc_flag = 26
     */
    superFmtDiscFlag: string;
    /**
     * @generated from protobuf field: string plano_other_flag = 27
     */
    planoOtherFlag: string;
    /**
     * Physical properties
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal item_weight_quantity = 28
     */
    itemWeightQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal each_length = 29
     */
    eachLength?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal each_width = 30
     */
    eachWidth?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal each_height = 31
     */
    eachHeight?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal each_volume = 32
     */
    eachVolume?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_pack_length = 33
     */
    casePackLength?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_pack_width = 34
     */
    casePackWidth?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_pack_height = 35
     */
    casePackHeight?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_pack_weight = 36
     */
    casePackWeight?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal case_pack_volume = 37
     */
    casePackVolume?: Decimal;
    /**
     * Status and change flags
     *
     * @generated from protobuf field: string item_status_code = 38
     */
    itemStatusCode: string; // A=Active, 9=To Be Discontinued, C/D=Discontinued
    /**
     * @generated from protobuf field: string change_code = 39
     */
    changeCode: string;
    /**
     * @generated from protobuf field: string central_warehouse_code = 40
     */
    centralWarehouseCode: string;
    /**
     * @generated from protobuf field: string central_warehouse_change_flag = 41
     */
    centralWarehouseChangeFlag: string;
    /**
     * @generated from protobuf field: string checklist_page = 42
     */
    checklistPage: string;
    /**
     * @generated from protobuf field: string data_type_code = 43
     */
    dataTypeCode: string;
    /**
     * @generated from protobuf field: string def_goods_code = 44
     */
    defGoodsCode: string;
    /**
     * @generated from protobuf field: string stock_expire_rec_code = 45
     */
    stockExpireRecCode: string;
    /**
     * @generated from protobuf field: string retrieve_level_department_code = 46
     */
    retrieveLevelDepartmentCode: string;
    /**
     * @generated from protobuf field: int32 stock_item_department = 47
     */
    stockItemDepartment: number;
    /**
     * @generated from protobuf field: string replenishable_flag = 48
     */
    replenishableFlag: string;
    /**
     * @generated from protobuf field: string b2b_flag = 49
     */
    b2BFlag: string;
    /**
     * Substitute/replacement
     *
     * @generated from protobuf field: string replenishment_stock_number = 50
     */
    replenishmentStockNumber: string;
    /**
     * Warranty
     *
     * @generated from protobuf field: string warranty_regulation_code = 51
     */
    warrantyRegulationCode: string;
    /**
     * Cost info
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney dealer_cost = 61
     */
    dealerCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney new_dealer_cost = 52
     */
    newDealerCost?: FractionalMoney;
    /**
     * @generated from protobuf field: string new_valid_from_date = 53
     */
    newValidFromDate: string;
    /**
     * Image URLs
     *
     * @generated from protobuf field: string url_pic = 54
     */
    urlPic: string;
    /**
     * @generated from protobuf field: string url_thumb = 55
     */
    urlThumb: string;
    /**
     * Selling unit of measure (from XML UnitOfMeasure field, Seq 24)
     *
     * @generated from protobuf field: string selling_uom = 56
     */
    sellingUom: string;
    /**
     * Order quantity
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal order_multiple_quantity = 57
     */
    orderMultipleQuantity?: Decimal;
}
/**
 * @generated from protobuf message rd.catalog.BlishMizeCatalogItem
 */
export interface BlishMizeCatalogItem {
    /**
     * Pricing fields
     *
     * @generated from protobuf field: rd.proto.money.Money dealer_retail = 1
     */
    dealerRetail?: Money;
    /**
     * Classification and identification
     *
     * @generated from protobuf field: string catalog_location = 2
     */
    catalogLocation: string;
    /**
     * @generated from protobuf field: string vendor_name = 3
     */
    vendorName: string;
    /**
     * @generated from protobuf field: string mfg_part_number = 4
     */
    mfgPartNumber: string;
    /**
     * @generated from protobuf field: string fine_line_class = 5
     */
    fineLineClass: string;
    /**
     * @generated from protobuf field: string retail_department = 6
     */
    retailDepartment: string;
    /**
     * Unit and pack fields
     *
     * @generated from protobuf field: string cost_unit = 7
     */
    costUnit: string;
    /**
     * @generated from protobuf field: string retail_unit = 8
     */
    retailUnit: string;
    /**
     * @generated from protobuf field: string stocking_unit_of_measure = 9
     */
    stockingUnitOfMeasure: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_unit_conversion = 10
     */
    retailUnitConversion?: Decimal;
    /**
     * @generated from protobuf field: string break_sell_pack = 11
     */
    breakSellPack: string;
    /**
     * Physical properties
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal weight = 12
     */
    weight?: Decimal;
    /**
     * Cost fields
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 13
     */
    cost?: FractionalMoney;
    /**
     * Order quantity
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal sell_pack = 14
     */
    sellPack?: Decimal;
}
/**
 * @generated from protobuf message rd.catalog.WallaceCatalogItem
 */
export interface WallaceCatalogItem {
    /**
     * @generated from protobuf field: string change_id = 1
     */
    changeId: string;
    /**
     * @generated from protobuf field: string department = 2
     */
    department: string;
    /**
     * @generated from protobuf field: string class = 3
     */
    class: string;
    /**
     * @generated from protobuf field: string fineline = 4
     */
    fineline: string;
    /**
     * @generated from protobuf field: string mfg_vendor = 5
     */
    mfgVendor: string;
    /**
     * @generated from protobuf field: string mfg_part_number = 6
     */
    mfgPartNumber: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney mfg_vendor_cost = 7
     */
    mfgVendorCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney replacement_cost = 8
     */
    replacementCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney retail_price = 9
     */
    retailPrice?: FractionalMoney;
    /**
     * @generated from protobuf field: int32 std_package = 10
     */
    stdPackage: number;
    /**
     * @generated from protobuf field: int32 standard_package = 11
     */
    standardPackage: number;
    /**
     * @generated from protobuf field: string purchase_uom = 12
     */
    purchaseUom: string;
    /**
     * @generated from protobuf field: string item_weight = 13
     */
    itemWeight: string;
    /**
     * @generated from protobuf field: string list_factor = 14
     */
    listFactor: string;
    /**
     * @generated from protobuf field: string gtin = 15
     */
    gtin: string;
    /**
     * @generated from protobuf field: string stocking_uom = 16
     */
    stockingUom: string;
}
/**
 * @generated from protobuf message rd.catalog.HouseHassonCatalogItem
 */
export interface HouseHassonCatalogItem {
    /**
     * @generated from protobuf field: string ship_unit = 1
     */
    shipUnit: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal stock_pack = 2
     */
    stockPack?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_pack = 3
     */
    retailPack?: Decimal;
    /**
     * @generated from protobuf field: string department = 4
     */
    department: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal weight = 5
     */
    weight?: Decimal;
    /**
     * @generated from protobuf field: string do_not_break_flag = 6
     */
    doNotBreakFlag: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_retail_price = 7
     */
    suggestedRetailPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 8
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: bool discontinued = 9
     */
    discontinued: boolean;
}
/**
 * @generated from protobuf message rd.catalog.SKU
 */
export interface SKU {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor vendor = 3
     */
    vendor: IntegrationVendor;
    /**
     * @generated from protobuf field: string sku = 4
     */
    sku: string;
    /**
     * @generated from protobuf field: string upc = 14
     */
    upc: string;
    /**
     * @generated from protobuf field: string description = 9
     */
    description: string; // equivalent of our product name
    /**
     * @generated from protobuf field: rd.catalog.DoItBestCatalogItem do_it_best_catalog_item = 24
     */
    doItBestCatalogItem?: DoItBestCatalogItem;
    /**
     * @generated from protobuf field: rd.catalog.OrgillCatalogItem orgill_catalog_item = 25
     */
    orgillCatalogItem?: OrgillCatalogItem;
    /**
     * @generated from protobuf field: rd.catalog.TrueValueCatalogItem true_value_catalog_item = 26
     */
    trueValueCatalogItem?: TrueValueCatalogItem;
    /**
     * @generated from protobuf field: rd.catalog.EmeryJensenCatalogItem emery_jensen_catalog_item = 28
     */
    emeryJensenCatalogItem?: EmeryJensenCatalogItem;
    /**
     * @generated from protobuf field: rd.catalog.WallaceCatalogItem wallace_catalog_item = 29
     */
    wallaceCatalogItem?: WallaceCatalogItem;
    /**
     * @generated from protobuf field: rd.catalog.BlishMizeCatalogItem blish_mize_catalog_item = 30
     */
    blishMizeCatalogItem?: BlishMizeCatalogItem;
    /**
     * @generated from protobuf field: rd.catalog.HouseHassonCatalogItem house_hasson_catalog_item = 31
     */
    houseHassonCatalogItem?: HouseHassonCatalogItem;
    /**
     * Account number for private catalogs (empty for public catalogs)
     *
     * @generated from protobuf field: string account_number = 27
     */
    accountNumber: string;
    /**
     * Used to send hybrid updates based on Visibility enum value
     *
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 32
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.search.cache.visibility.Visibility visibility = 33
     */
    visibility: Visibility;
    /**
     * @generated from protobuf field: rd.catalog.SKU.Origin origin = 34
     */
    origin: SKU_Origin;
}
/**
 * @generated from protobuf enum rd.catalog.SKU.Origin
 */
export enum SKU_Origin {
    /**
     * @generated from protobuf enum value: ORIGIN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ORIGIN_CATALOG = 1;
     */
    CATALOG = 1,
    /**
     * @generated from protobuf enum value: ORIGIN_ITEM_MAINTENANCE = 2;
     */
    ITEM_MAINTENANCE = 2
}
/**
 * OrgillWarehouseItem contains Orgill-specific warehouse inventory information.
 * Fields sourced from per-DC Standard Data File (Orgill-Standard-Data-File-DC-XXX.xlsx)
 * and WEB_INVENTORY.TXT.
 *
 * @generated from protobuf message rd.catalog.OrgillWarehouseItem
 */
export interface OrgillWarehouseItem {
    /**
     * @generated from protobuf field: int32 inventory = 1
     */
    inventory: number;
    /**
     * @generated from protobuf field: string velocity_code = 2
     */
    velocityCode: string;
    /**
     * @generated from protobuf field: string replacement_item = 3
     */
    replacementItem: string;
    /**
     * @generated from protobuf field: string substitute_item = 4
     */
    substituteItem: string;
    /**
     * @generated from protobuf field: int32 min_purchase_multiple = 5
     */
    minPurchaseMultiple: number;
    /**
     * @generated from protobuf field: int32 shelf_pack = 6
     */
    shelfPack: number;
    /**
     * @generated from protobuf field: string quantity_round_option = 7
     */
    quantityRoundOption: string;
}
/**
 * DoItBestWarehouseItem contains Do It Best RSC-specific warehouse information
 *
 * @generated from protobuf message rd.catalog.DoItBestWarehouseItem
 */
export interface DoItBestWarehouseItem {
    /**
     * @generated from protobuf field: int32 inventory = 1
     */
    inventory: number;
    /**
     * @generated from protobuf field: string product_code = 2
     */
    productCode: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp estimated_in_stock_date = 3
     */
    estimatedInStockDate?: Timestamp;
}
/**
 * TrueValueWarehouseItem contains True Value RDC-specific warehouse information
 *
 * @generated from protobuf message rd.catalog.TrueValueWarehouseItem
 */
export interface TrueValueWarehouseItem {
    /**
     * @generated from protobuf field: int32 inventory = 1
     */
    inventory: number;
}
/**
 * @generated from protobuf message rd.catalog.EmeryJensenWarehouseItem
 */
export interface EmeryJensenWarehouseItem {
    /**
     * @generated from protobuf field: int32 inventory = 1
     */
    inventory: number;
}
/**
 * WarehouseInfo tracks vendor warehouse inventory and details for a specific SKU.
 * Similar to SKU, but focuses on warehouse-level data like inventory quantities.
 *
 * @generated from protobuf message rd.catalog.WarehouseInfo
 */
export interface WarehouseInfo {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * Core identifiers
     *
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor vendor = 4
     */
    vendor: IntegrationVendor;
    /**
     * @generated from protobuf field: string warehouse_location = 5
     */
    warehouseLocation: string; // Vendor's warehouse (e.g., "001", "001a", "CHI-1")
    /**
     * @generated from protobuf field: string sku = 6
     */
    sku: string;
    /**
     * @generated from protobuf field: string account_number = 7
     */
    accountNumber: string; // Account number for private catalogs (empty for public catalogs)
    /**
     * Vendor-specific warehouse details (one of these will be populated)
     *
     * @generated from protobuf field: rd.catalog.OrgillWarehouseItem orgill_warehouse_item = 8
     */
    orgillWarehouseItem?: OrgillWarehouseItem;
    /**
     * @generated from protobuf field: rd.catalog.DoItBestWarehouseItem do_it_best_warehouse_item = 9
     */
    doItBestWarehouseItem?: DoItBestWarehouseItem;
    /**
     * @generated from protobuf field: rd.catalog.TrueValueWarehouseItem true_value_warehouse_item = 10
     */
    trueValueWarehouseItem?: TrueValueWarehouseItem;
    /**
     * @generated from protobuf field: rd.catalog.EmeryJensenWarehouseItem emery_jensen_warehouse_item = 11
     */
    emeryJensenWarehouseItem?: EmeryJensenWarehouseItem;
    /**
     * Used to send hybrid updates based on Visibility enum value
     *
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 12
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.search.cache.visibility.Visibility visibility = 33
     */
    visibility: Visibility;
}
/**
 * @generated from protobuf enum rd.catalog.DoItBestDepartment
 */
export enum DoItBestDepartment {
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Note: Department code "00" (None) maps to 0/UNSPECIFIED
     *
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_BEST_REWARDS_COUPON_ITEMS = 1;
     */
    BEST_REWARDS_COUPON_ITEMS = 1,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_LUMBER_BUILDING_MATERIALS = 10;
     */
    LUMBER_BUILDING_MATERIALS = 10,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_MILLWORK = 16;
     */
    MILLWORK = 16,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_BUILDERS_HARDWARE = 20;
     */
    BUILDERS_HARDWARE = 20,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_BUILDING_SPECIALTIES = 26;
     */
    BUILDING_SPECIALTIES = 26,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_TOOLS = 30;
     */
    TOOLS = 30,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_PLUMBING_AND_HEATING = 40;
     */
    PLUMBING_AND_HEATING = 40,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_ELECTRICAL_SUPPLIES = 50;
     */
    ELECTRICAL_SUPPLIES = 50,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_AUTOMOTIVE = 57;
     */
    AUTOMOTIVE = 57,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_HOUSEWARE = 60;
     */
    HOUSEWARE = 60,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_GIFTS_PORTABLE_APPLIANCE = 65;
     */
    GIFTS_PORTABLE_APPLIANCE = 65,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_FARM_LAWN_GARDEN = 70;
     */
    FARM_LAWN_GARDEN = 70,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_PAINT_AND_SUNDRIES = 77;
     */
    PAINT_AND_SUNDRIES = 77,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_OUTDOOR_LIVING = 80;
     */
    OUTDOOR_LIVING = 80,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_TOYS_AND_WHEEL_GOODS = 90;
     */
    TOYS_AND_WHEEL_GOODS = 90,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_STATIONARY_ARTS_CRAFTS = 97;
     */
    STATIONARY_ARTS_CRAFTS = 97,
    /**
     * @generated from protobuf enum value: DO_IT_BEST_DEPARTMENT_STORE_SUPPLIES = 99;
     */
    STORE_SUPPLIES = 99
}
// @generated message type with reflection information, may provide speed optimized methods
class DiscontinuedStatus$Type extends MessageType<DiscontinuedStatus> {
    constructor() {
        super("rd.catalog.DiscontinuedStatus", [
            { no: 1, name: "discontinued", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "to_be_discontinued", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DiscontinuedStatus>): DiscontinuedStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.discontinued = false;
        message.toBeDiscontinued = false;
        if (value !== undefined)
            reflectionMergePartial<DiscontinuedStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DiscontinuedStatus): DiscontinuedStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool discontinued */ 1:
                    message.discontinued = reader.bool();
                    break;
                case /* bool to_be_discontinued */ 2:
                    message.toBeDiscontinued = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DiscontinuedStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool discontinued = 1; */
        if (message.discontinued !== false)
            writer.tag(1, WireType.Varint).bool(message.discontinued);
        /* bool to_be_discontinued = 2; */
        if (message.toBeDiscontinued !== false)
            writer.tag(2, WireType.Varint).bool(message.toBeDiscontinued);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.DiscontinuedStatus
 */
export const DiscontinuedStatus = new DiscontinuedStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubstituteInfo$Type extends MessageType<SubstituteInfo> {
    constructor() {
        super("rd.catalog.SubstituteInfo", [
            { no: 1, name: "alternative_sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.catalog.SubstituteInfo.AlternativeType", SubstituteInfo_AlternativeType, "ALTERNATIVE_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SubstituteInfo>): SubstituteInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alternativeSku = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<SubstituteInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubstituteInfo): SubstituteInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string alternative_sku */ 1:
                    message.alternativeSku = reader.string();
                    break;
                case /* rd.catalog.SubstituteInfo.AlternativeType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubstituteInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string alternative_sku = 1; */
        if (message.alternativeSku !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.alternativeSku);
        /* rd.catalog.SubstituteInfo.AlternativeType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.SubstituteInfo
 */
export const SubstituteInfo = new SubstituteInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostLineItem$Type extends MessageType<CostLineItem> {
    constructor() {
        super("rd.catalog.CostLineItem", [
            { no: 1, name: "severity", kind: "enum", T: () => ["rd.catalog.CostLineItem.Severity", CostLineItem_Severity] },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cost", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<CostLineItem>): CostLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.severity = 0;
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial<CostLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CostLineItem): CostLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.catalog.CostLineItem.Severity severity */ 1:
                    message.severity = reader.int32();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 3:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CostLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.catalog.CostLineItem.Severity severity = 1; */
        if (message.severity !== 0)
            writer.tag(1, WireType.Varint).int32(message.severity);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* rd.proto.money.FractionalMoney cost = 3; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.CostLineItem
 */
export const CostLineItem = new CostLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderSuggestion$Type extends MessageType<OrderSuggestion> {
    constructor() {
        super("rd.catalog.OrderSuggestion", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.catalog.OrderSuggestion.Type", OrderSuggestion_Type] },
            { no: 2, name: "severity", kind: "enum", T: () => ["rd.catalog.OrderSuggestion.Severity", OrderSuggestion_Severity] },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "button_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "updated_quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<OrderSuggestion>): OrderSuggestion {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.severity = 0;
        message.message = "";
        message.buttonMessage = "";
        message.updatedQuantity = 0;
        if (value !== undefined)
            reflectionMergePartial<OrderSuggestion>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderSuggestion): OrderSuggestion {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.catalog.OrderSuggestion.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.catalog.OrderSuggestion.Severity severity */ 2:
                    message.severity = reader.int32();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* string button_message */ 4:
                    message.buttonMessage = reader.string();
                    break;
                case /* int32 updated_quantity */ 5:
                    message.updatedQuantity = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderSuggestion, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.catalog.OrderSuggestion.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.catalog.OrderSuggestion.Severity severity = 2; */
        if (message.severity !== 0)
            writer.tag(2, WireType.Varint).int32(message.severity);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* string button_message = 4; */
        if (message.buttonMessage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.buttonMessage);
        /* int32 updated_quantity = 5; */
        if (message.updatedQuantity !== 0)
            writer.tag(5, WireType.Varint).int32(message.updatedQuantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.OrderSuggestion
 */
export const OrderSuggestion = new OrderSuggestion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputedSKUInfo$Type extends MessageType<ComputedSKUInfo> {
    constructor() {
        super("rd.catalog.ComputedSKUInfo", [
            { no: 1, name: "discontinued_status", kind: "message", T: () => DiscontinuedStatus },
            { no: 2, name: "substitute_info", kind: "message", T: () => SubstituteInfo },
            { no: 3, name: "unit_cost", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "retail_price", kind: "message", T: () => Money },
            { no: 5, name: "ordering_uom_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "case_quantity", kind: "message", T: () => Decimal },
            { no: 7, name: "retail_uom_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "retail_uom_conversion_factor", kind: "message", T: () => Decimal },
            { no: 9, name: "inventory", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ComputedSKUInfo>): ComputedSKUInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.orderingUomLabel = "";
        message.retailUomLabel = "";
        if (value !== undefined)
            reflectionMergePartial<ComputedSKUInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ComputedSKUInfo): ComputedSKUInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.catalog.DiscontinuedStatus discontinued_status */ 1:
                    message.discontinuedStatus = DiscontinuedStatus.internalBinaryRead(reader, reader.uint32(), options, message.discontinuedStatus);
                    break;
                case /* rd.catalog.SubstituteInfo substitute_info */ 2:
                    message.substituteInfo = SubstituteInfo.internalBinaryRead(reader, reader.uint32(), options, message.substituteInfo);
                    break;
                case /* rd.proto.money.FractionalMoney unit_cost */ 3:
                    message.unitCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitCost);
                    break;
                case /* rd.proto.money.Money retail_price */ 4:
                    message.retailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.retailPrice);
                    break;
                case /* string ordering_uom_label */ 5:
                    message.orderingUomLabel = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal case_quantity */ 6:
                    message.caseQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.caseQuantity);
                    break;
                case /* string retail_uom_label */ 7:
                    message.retailUomLabel = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal retail_uom_conversion_factor */ 8:
                    message.retailUomConversionFactor = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailUomConversionFactor);
                    break;
                case /* optional int32 inventory */ 9:
                    message.inventory = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ComputedSKUInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.catalog.DiscontinuedStatus discontinued_status = 1; */
        if (message.discontinuedStatus)
            DiscontinuedStatus.internalBinaryWrite(message.discontinuedStatus, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.SubstituteInfo substitute_info = 2; */
        if (message.substituteInfo)
            SubstituteInfo.internalBinaryWrite(message.substituteInfo, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney unit_cost = 3; */
        if (message.unitCost)
            FractionalMoney.internalBinaryWrite(message.unitCost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money retail_price = 4; */
        if (message.retailPrice)
            Money.internalBinaryWrite(message.retailPrice, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string ordering_uom_label = 5; */
        if (message.orderingUomLabel !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.orderingUomLabel);
        /* rd.proto.decimal.Decimal case_quantity = 6; */
        if (message.caseQuantity)
            Decimal.internalBinaryWrite(message.caseQuantity, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string retail_uom_label = 7; */
        if (message.retailUomLabel !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.retailUomLabel);
        /* rd.proto.decimal.Decimal retail_uom_conversion_factor = 8; */
        if (message.retailUomConversionFactor)
            Decimal.internalBinaryWrite(message.retailUomConversionFactor, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 inventory = 9; */
        if (message.inventory !== undefined)
            writer.tag(9, WireType.Varint).int32(message.inventory);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.ComputedSKUInfo
 */
export const ComputedSKUInfo = new ComputedSKUInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product$Type extends MessageType<Product> {
    constructor() {
        super("rd.catalog.Product", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "suggested_retail", kind: "message", T: () => Money },
            { no: 10, name: "title_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "long_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "attributes", kind: "message", T: () => Product_Attributes },
            { no: 14, name: "image_urls", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product_ProductImages },
            { no: 15, name: "long_description_source", kind: "enum", T: () => ["rd.catalog.Product.DescriptionSource", Product_DescriptionSource, "DESCRIPTION_SOURCE_"] }
        ]);
    }
    create(value?: PartialMessage<Product>): Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.upc = "";
        message.name = "";
        message.titleDescription = "";
        message.longDescription = "";
        message.imageUrls = [];
        message.longDescriptionSource = 0;
        if (value !== undefined)
            reflectionMergePartial<Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product): Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string upc */ 4:
                    message.upc = reader.string();
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money suggested_retail */ 7:
                    message.suggestedRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedRetail);
                    break;
                case /* string title_description */ 10:
                    message.titleDescription = reader.string();
                    break;
                case /* string long_description */ 11:
                    message.longDescription = reader.string();
                    break;
                case /* rd.catalog.Product.Attributes attributes */ 13:
                    message.attributes = Product_Attributes.internalBinaryRead(reader, reader.uint32(), options, message.attributes);
                    break;
                case /* repeated rd.catalog.Product.ProductImages image_urls */ 14:
                    message.imageUrls.push(Product_ProductImages.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.catalog.Product.DescriptionSource long_description_source */ 15:
                    message.longDescriptionSource = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string upc = 4; */
        if (message.upc !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.upc);
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money suggested_retail = 7; */
        if (message.suggestedRetail)
            Money.internalBinaryWrite(message.suggestedRetail, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string title_description = 10; */
        if (message.titleDescription !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.titleDescription);
        /* string long_description = 11; */
        if (message.longDescription !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.longDescription);
        /* rd.catalog.Product.Attributes attributes = 13; */
        if (message.attributes)
            Product_Attributes.internalBinaryWrite(message.attributes, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.catalog.Product.ProductImages image_urls = 14; */
        for (let i = 0; i < message.imageUrls.length; i++)
            Product_ProductImages.internalBinaryWrite(message.imageUrls[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.Product.DescriptionSource long_description_source = 15; */
        if (message.longDescriptionSource !== 0)
            writer.tag(15, WireType.Varint).int32(message.longDescriptionSource);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.Product
 */
export const Product = new Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_Attributes$Type extends MessageType<Product_Attributes> {
    constructor() {
        super("rd.catalog.Product.Attributes", [
            { no: 1, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "country_of_origin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "hazardous", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "weight", kind: "message", T: () => Decimal },
            { no: 6, name: "length", kind: "message", T: () => Decimal },
            { no: 7, name: "width", kind: "message", T: () => Decimal },
            { no: 8, name: "height", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Product_Attributes>): Product_Attributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.manufacturer = "";
        message.modelNumber = "";
        message.countryOfOrigin = "";
        message.hazardous = "";
        if (value !== undefined)
            reflectionMergePartial<Product_Attributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_Attributes): Product_Attributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string manufacturer */ 1:
                    message.manufacturer = reader.string();
                    break;
                case /* string model_number */ 2:
                    message.modelNumber = reader.string();
                    break;
                case /* string country_of_origin */ 3:
                    message.countryOfOrigin = reader.string();
                    break;
                case /* string hazardous */ 4:
                    message.hazardous = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal weight */ 5:
                    message.weight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* rd.proto.decimal.Decimal length */ 6:
                    message.length = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.length);
                    break;
                case /* rd.proto.decimal.Decimal width */ 7:
                    message.width = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.width);
                    break;
                case /* rd.proto.decimal.Decimal height */ 8:
                    message.height = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_Attributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string manufacturer = 1; */
        if (message.manufacturer !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.manufacturer);
        /* string model_number = 2; */
        if (message.modelNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelNumber);
        /* string country_of_origin = 3; */
        if (message.countryOfOrigin !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.countryOfOrigin);
        /* string hazardous = 4; */
        if (message.hazardous !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.hazardous);
        /* rd.proto.decimal.Decimal weight = 5; */
        if (message.weight)
            Decimal.internalBinaryWrite(message.weight, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal length = 6; */
        if (message.length)
            Decimal.internalBinaryWrite(message.length, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal width = 7; */
        if (message.width)
            Decimal.internalBinaryWrite(message.width, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal height = 8; */
        if (message.height)
            Decimal.internalBinaryWrite(message.height, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.Product.Attributes
 */
export const Product_Attributes = new Product_Attributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Product_ProductImages$Type extends MessageType<Product_ProductImages> {
    constructor() {
        super("rd.catalog.Product.ProductImages", [
            { no: 1, name: "original_url_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rundoo_cdn_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] }
        ]);
    }
    create(value?: PartialMessage<Product_ProductImages>): Product_ProductImages {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.originalUrlHash = "";
        message.rundooCdnUrl = "";
        message.vendor = 0;
        if (value !== undefined)
            reflectionMergePartial<Product_ProductImages>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Product_ProductImages): Product_ProductImages {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string original_url_hash */ 1:
                    message.originalUrlHash = reader.string();
                    break;
                case /* string rundoo_cdn_url */ 2:
                    message.rundooCdnUrl = reader.string();
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor vendor */ 3:
                    message.vendor = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Product_ProductImages, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string original_url_hash = 1; */
        if (message.originalUrlHash !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.originalUrlHash);
        /* string rundoo_cdn_url = 2; */
        if (message.rundooCdnUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.rundooCdnUrl);
        /* rd.proto.integration_vendor.IntegrationVendor vendor = 3; */
        if (message.vendor !== 0)
            writer.tag(3, WireType.Varint).int32(message.vendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.Product.ProductImages
 */
export const Product_ProductImages = new Product_ProductImages$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BigProductData$Type extends MessageType<BigProductData> {
    constructor() {
        super("rd.catalog.BigProductData", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "json_payload", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "http_status_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BigProductData>): BigProductData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.upc = "";
        message.jsonPayload = "";
        message.httpStatusCode = 0;
        if (value !== undefined)
            reflectionMergePartial<BigProductData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BigProductData): BigProductData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string upc */ 2:
                    message.upc = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string json_payload */ 5:
                    message.jsonPayload = reader.string();
                    break;
                case /* int32 http_status_code */ 6:
                    message.httpStatusCode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BigProductData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string upc = 2; */
        if (message.upc !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.upc);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string json_payload = 5; */
        if (message.jsonPayload !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.jsonPayload);
        /* int32 http_status_code = 6; */
        if (message.httpStatusCode !== 0)
            writer.tag(6, WireType.Varint).int32(message.httpStatusCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.BigProductData
 */
export const BigProductData = new BigProductData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DoItBestCatalogItem$Type extends MessageType<DoItBestCatalogItem> {
    constructor() {
        super("rd.catalog.DoItBestCatalogItem", [
            { no: 1, name: "suggested_retail", kind: "message", T: () => Money },
            { no: 2, name: "suggested_aux_retail", kind: "message", T: () => Money },
            { no: 53, name: "classic_1_cost", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "classic_2_cost", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "classic_3_cost", kind: "message", T: () => FractionalMoney },
            { no: 5, name: "vision_1_cost", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "vision_2_cost", kind: "message", T: () => FractionalMoney },
            { no: 7, name: "vision_3_cost", kind: "message", T: () => FractionalMoney },
            { no: 8, name: "par_1_cost", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "par_2_cost", kind: "message", T: () => FractionalMoney },
            { no: 10, name: "par_3_cost", kind: "message", T: () => FractionalMoney },
            { no: 11, name: "drop_ship_cost", kind: "message", T: () => FractionalMoney },
            { no: 12, name: "gross_margin", kind: "message", T: () => Decimal },
            { no: 13, name: "suggested_aux_margin", kind: "message", T: () => Decimal },
            { no: 14, name: "suggested_classic_margin", kind: "message", T: () => Decimal },
            { no: 15, name: "suggested_vision_margin", kind: "message", T: () => Decimal },
            { no: 16, name: "suggested_par_margin", kind: "message", T: () => Decimal },
            { no: 17, name: "rsc_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "vendor_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "vendor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "department", kind: "enum", T: () => ["rd.catalog.DoItBestDepartment", DoItBestDepartment, "DO_IT_BEST_DEPARTMENT_"] },
            { no: 21, name: "product_classification_department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "product_group", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "mult_1", kind: "message", T: () => Decimal },
            { no: 24, name: "mult_2", kind: "message", T: () => Decimal },
            { no: 25, name: "mult_3", kind: "message", T: () => Decimal },
            { no: 26, name: "case_multiple_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "aux_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "aux_quantity", kind: "message", T: () => Decimal },
            { no: 29, name: "unit_weight", kind: "message", T: () => Decimal },
            { no: 30, name: "unit_cube", kind: "message", T: () => Decimal },
            { no: 31, name: "status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "item_type_switch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "new_item_indicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "promo_status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "substitute_item_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "country_of_origin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "return_goods_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "price_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "product_code_pkg_switch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "ups_switch", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 41, name: "central_stock_switch", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 42, name: "cs_primary_rsc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "cs_secondary_rsc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "exception_quantity", kind: "message", T: () => Decimal },
            { no: 45, name: "maximum_quantity", kind: "message", T: () => Decimal },
            { no: 46, name: "max_quantity_switch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 47, name: "private_label", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 48, name: "private_label_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "load_date", kind: "message", T: () => Timestamp },
            { no: 50, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 52, name: "member_retail", kind: "message", T: () => Money },
            { no: 54, name: "manufacturer_part_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 55, name: "coupon_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 56, name: "coupon_tax", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 57, name: "fine_line_class_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 58, name: "unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 59, name: "substitute_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 60, name: "master_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 61, name: "other_image_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DoItBestCatalogItem>): DoItBestCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rscCode = "";
        message.vendorNumber = "";
        message.vendorName = "";
        message.department = 0;
        message.productClassificationDepartment = "";
        message.productGroup = "";
        message.caseMultipleCode = "";
        message.auxUnit = "";
        message.statusCode = "";
        message.itemTypeSwitch = "";
        message.newItemIndicator = "";
        message.promoStatusCode = "";
        message.substituteItem2 = "";
        message.countryOfOrigin = "";
        message.returnGoodsCode = "";
        message.priceCode = "";
        message.productCodePkgSwitch = "";
        message.upsSwitch = false;
        message.centralStockSwitch = false;
        message.csPrimaryRsc = "";
        message.csSecondaryRsc = "";
        message.maxQuantitySwitch = "";
        message.privateLabel = false;
        message.privateLabelDescription = "";
        message.manufacturerPartNumber = "";
        message.couponCode = "";
        message.couponTax = "";
        message.fineLineClassCode = "";
        message.unit = "";
        message.substituteItem = "";
        message.masterImageUrl = "";
        message.otherImageUrls = [];
        if (value !== undefined)
            reflectionMergePartial<DoItBestCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DoItBestCatalogItem): DoItBestCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money suggested_retail */ 1:
                    message.suggestedRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedRetail);
                    break;
                case /* rd.proto.money.Money suggested_aux_retail */ 2:
                    message.suggestedAuxRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedAuxRetail);
                    break;
                case /* rd.proto.money.FractionalMoney classic_1_cost */ 53:
                    message.classic1Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.classic1Cost);
                    break;
                case /* rd.proto.money.FractionalMoney classic_2_cost */ 3:
                    message.classic2Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.classic2Cost);
                    break;
                case /* rd.proto.money.FractionalMoney classic_3_cost */ 4:
                    message.classic3Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.classic3Cost);
                    break;
                case /* rd.proto.money.FractionalMoney vision_1_cost */ 5:
                    message.vision1Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.vision1Cost);
                    break;
                case /* rd.proto.money.FractionalMoney vision_2_cost */ 6:
                    message.vision2Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.vision2Cost);
                    break;
                case /* rd.proto.money.FractionalMoney vision_3_cost */ 7:
                    message.vision3Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.vision3Cost);
                    break;
                case /* rd.proto.money.FractionalMoney par_1_cost */ 8:
                    message.par1Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.par1Cost);
                    break;
                case /* rd.proto.money.FractionalMoney par_2_cost */ 9:
                    message.par2Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.par2Cost);
                    break;
                case /* rd.proto.money.FractionalMoney par_3_cost */ 10:
                    message.par3Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.par3Cost);
                    break;
                case /* rd.proto.money.FractionalMoney drop_ship_cost */ 11:
                    message.dropShipCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.dropShipCost);
                    break;
                case /* rd.proto.decimal.Decimal gross_margin */ 12:
                    message.grossMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.grossMargin);
                    break;
                case /* rd.proto.decimal.Decimal suggested_aux_margin */ 13:
                    message.suggestedAuxMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.suggestedAuxMargin);
                    break;
                case /* rd.proto.decimal.Decimal suggested_classic_margin */ 14:
                    message.suggestedClassicMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.suggestedClassicMargin);
                    break;
                case /* rd.proto.decimal.Decimal suggested_vision_margin */ 15:
                    message.suggestedVisionMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.suggestedVisionMargin);
                    break;
                case /* rd.proto.decimal.Decimal suggested_par_margin */ 16:
                    message.suggestedParMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.suggestedParMargin);
                    break;
                case /* string rsc_code */ 17:
                    message.rscCode = reader.string();
                    break;
                case /* string vendor_number */ 18:
                    message.vendorNumber = reader.string();
                    break;
                case /* string vendor_name */ 19:
                    message.vendorName = reader.string();
                    break;
                case /* rd.catalog.DoItBestDepartment department */ 20:
                    message.department = reader.int32();
                    break;
                case /* string product_classification_department */ 21:
                    message.productClassificationDepartment = reader.string();
                    break;
                case /* string product_group */ 22:
                    message.productGroup = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal mult_1 */ 23:
                    message.mult1 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.mult1);
                    break;
                case /* rd.proto.decimal.Decimal mult_2 */ 24:
                    message.mult2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.mult2);
                    break;
                case /* rd.proto.decimal.Decimal mult_3 */ 25:
                    message.mult3 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.mult3);
                    break;
                case /* string case_multiple_code */ 26:
                    message.caseMultipleCode = reader.string();
                    break;
                case /* string aux_unit */ 27:
                    message.auxUnit = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal aux_quantity */ 28:
                    message.auxQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.auxQuantity);
                    break;
                case /* rd.proto.decimal.Decimal unit_weight */ 29:
                    message.unitWeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitWeight);
                    break;
                case /* rd.proto.decimal.Decimal unit_cube */ 30:
                    message.unitCube = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitCube);
                    break;
                case /* string status_code */ 31:
                    message.statusCode = reader.string();
                    break;
                case /* string item_type_switch */ 32:
                    message.itemTypeSwitch = reader.string();
                    break;
                case /* string new_item_indicator */ 33:
                    message.newItemIndicator = reader.string();
                    break;
                case /* string promo_status_code */ 34:
                    message.promoStatusCode = reader.string();
                    break;
                case /* string substitute_item_2 */ 35:
                    message.substituteItem2 = reader.string();
                    break;
                case /* string country_of_origin */ 36:
                    message.countryOfOrigin = reader.string();
                    break;
                case /* string return_goods_code */ 37:
                    message.returnGoodsCode = reader.string();
                    break;
                case /* string price_code */ 38:
                    message.priceCode = reader.string();
                    break;
                case /* string product_code_pkg_switch */ 39:
                    message.productCodePkgSwitch = reader.string();
                    break;
                case /* bool ups_switch */ 40:
                    message.upsSwitch = reader.bool();
                    break;
                case /* bool central_stock_switch */ 41:
                    message.centralStockSwitch = reader.bool();
                    break;
                case /* string cs_primary_rsc */ 42:
                    message.csPrimaryRsc = reader.string();
                    break;
                case /* string cs_secondary_rsc */ 43:
                    message.csSecondaryRsc = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal exception_quantity */ 44:
                    message.exceptionQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.exceptionQuantity);
                    break;
                case /* rd.proto.decimal.Decimal maximum_quantity */ 45:
                    message.maximumQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.maximumQuantity);
                    break;
                case /* string max_quantity_switch */ 46:
                    message.maxQuantitySwitch = reader.string();
                    break;
                case /* bool private_label */ 47:
                    message.privateLabel = reader.bool();
                    break;
                case /* string private_label_description */ 48:
                    message.privateLabelDescription = reader.string();
                    break;
                case /* google.protobuf.Timestamp load_date */ 49:
                    message.loadDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.loadDate);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 50:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* rd.proto.money.Money member_retail */ 52:
                    message.memberRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.memberRetail);
                    break;
                case /* string manufacturer_part_number */ 54:
                    message.manufacturerPartNumber = reader.string();
                    break;
                case /* string coupon_code */ 55:
                    message.couponCode = reader.string();
                    break;
                case /* string coupon_tax */ 56:
                    message.couponTax = reader.string();
                    break;
                case /* string fine_line_class_code */ 57:
                    message.fineLineClassCode = reader.string();
                    break;
                case /* string unit */ 58:
                    message.unit = reader.string();
                    break;
                case /* string substitute_item */ 59:
                    message.substituteItem = reader.string();
                    break;
                case /* string master_image_url */ 60:
                    message.masterImageUrl = reader.string();
                    break;
                case /* repeated string other_image_urls */ 61:
                    message.otherImageUrls.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DoItBestCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money suggested_retail = 1; */
        if (message.suggestedRetail)
            Money.internalBinaryWrite(message.suggestedRetail, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money suggested_aux_retail = 2; */
        if (message.suggestedAuxRetail)
            Money.internalBinaryWrite(message.suggestedAuxRetail, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney classic_2_cost = 3; */
        if (message.classic2Cost)
            FractionalMoney.internalBinaryWrite(message.classic2Cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney classic_3_cost = 4; */
        if (message.classic3Cost)
            FractionalMoney.internalBinaryWrite(message.classic3Cost, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney vision_1_cost = 5; */
        if (message.vision1Cost)
            FractionalMoney.internalBinaryWrite(message.vision1Cost, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney vision_2_cost = 6; */
        if (message.vision2Cost)
            FractionalMoney.internalBinaryWrite(message.vision2Cost, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney vision_3_cost = 7; */
        if (message.vision3Cost)
            FractionalMoney.internalBinaryWrite(message.vision3Cost, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney par_1_cost = 8; */
        if (message.par1Cost)
            FractionalMoney.internalBinaryWrite(message.par1Cost, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney par_2_cost = 9; */
        if (message.par2Cost)
            FractionalMoney.internalBinaryWrite(message.par2Cost, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney par_3_cost = 10; */
        if (message.par3Cost)
            FractionalMoney.internalBinaryWrite(message.par3Cost, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney drop_ship_cost = 11; */
        if (message.dropShipCost)
            FractionalMoney.internalBinaryWrite(message.dropShipCost, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal gross_margin = 12; */
        if (message.grossMargin)
            Decimal.internalBinaryWrite(message.grossMargin, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal suggested_aux_margin = 13; */
        if (message.suggestedAuxMargin)
            Decimal.internalBinaryWrite(message.suggestedAuxMargin, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal suggested_classic_margin = 14; */
        if (message.suggestedClassicMargin)
            Decimal.internalBinaryWrite(message.suggestedClassicMargin, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal suggested_vision_margin = 15; */
        if (message.suggestedVisionMargin)
            Decimal.internalBinaryWrite(message.suggestedVisionMargin, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal suggested_par_margin = 16; */
        if (message.suggestedParMargin)
            Decimal.internalBinaryWrite(message.suggestedParMargin, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* string rsc_code = 17; */
        if (message.rscCode !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.rscCode);
        /* string vendor_number = 18; */
        if (message.vendorNumber !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.vendorNumber);
        /* string vendor_name = 19; */
        if (message.vendorName !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.vendorName);
        /* rd.catalog.DoItBestDepartment department = 20; */
        if (message.department !== 0)
            writer.tag(20, WireType.Varint).int32(message.department);
        /* string product_classification_department = 21; */
        if (message.productClassificationDepartment !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.productClassificationDepartment);
        /* string product_group = 22; */
        if (message.productGroup !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.productGroup);
        /* rd.proto.decimal.Decimal mult_1 = 23; */
        if (message.mult1)
            Decimal.internalBinaryWrite(message.mult1, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal mult_2 = 24; */
        if (message.mult2)
            Decimal.internalBinaryWrite(message.mult2, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal mult_3 = 25; */
        if (message.mult3)
            Decimal.internalBinaryWrite(message.mult3, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* string case_multiple_code = 26; */
        if (message.caseMultipleCode !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.caseMultipleCode);
        /* string aux_unit = 27; */
        if (message.auxUnit !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.auxUnit);
        /* rd.proto.decimal.Decimal aux_quantity = 28; */
        if (message.auxQuantity)
            Decimal.internalBinaryWrite(message.auxQuantity, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal unit_weight = 29; */
        if (message.unitWeight)
            Decimal.internalBinaryWrite(message.unitWeight, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal unit_cube = 30; */
        if (message.unitCube)
            Decimal.internalBinaryWrite(message.unitCube, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* string status_code = 31; */
        if (message.statusCode !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.statusCode);
        /* string item_type_switch = 32; */
        if (message.itemTypeSwitch !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.itemTypeSwitch);
        /* string new_item_indicator = 33; */
        if (message.newItemIndicator !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.newItemIndicator);
        /* string promo_status_code = 34; */
        if (message.promoStatusCode !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.promoStatusCode);
        /* string substitute_item_2 = 35; */
        if (message.substituteItem2 !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.substituteItem2);
        /* string country_of_origin = 36; */
        if (message.countryOfOrigin !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.countryOfOrigin);
        /* string return_goods_code = 37; */
        if (message.returnGoodsCode !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.returnGoodsCode);
        /* string price_code = 38; */
        if (message.priceCode !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.priceCode);
        /* string product_code_pkg_switch = 39; */
        if (message.productCodePkgSwitch !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.productCodePkgSwitch);
        /* bool ups_switch = 40; */
        if (message.upsSwitch !== false)
            writer.tag(40, WireType.Varint).bool(message.upsSwitch);
        /* bool central_stock_switch = 41; */
        if (message.centralStockSwitch !== false)
            writer.tag(41, WireType.Varint).bool(message.centralStockSwitch);
        /* string cs_primary_rsc = 42; */
        if (message.csPrimaryRsc !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.csPrimaryRsc);
        /* string cs_secondary_rsc = 43; */
        if (message.csSecondaryRsc !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.csSecondaryRsc);
        /* rd.proto.decimal.Decimal exception_quantity = 44; */
        if (message.exceptionQuantity)
            Decimal.internalBinaryWrite(message.exceptionQuantity, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal maximum_quantity = 45; */
        if (message.maximumQuantity)
            Decimal.internalBinaryWrite(message.maximumQuantity, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* string max_quantity_switch = 46; */
        if (message.maxQuantitySwitch !== "")
            writer.tag(46, WireType.LengthDelimited).string(message.maxQuantitySwitch);
        /* bool private_label = 47; */
        if (message.privateLabel !== false)
            writer.tag(47, WireType.Varint).bool(message.privateLabel);
        /* string private_label_description = 48; */
        if (message.privateLabelDescription !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.privateLabelDescription);
        /* google.protobuf.Timestamp load_date = 49; */
        if (message.loadDate)
            Timestamp.internalBinaryWrite(message.loadDate, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 50; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money member_retail = 52; */
        if (message.memberRetail)
            Money.internalBinaryWrite(message.memberRetail, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney classic_1_cost = 53; */
        if (message.classic1Cost)
            FractionalMoney.internalBinaryWrite(message.classic1Cost, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* string manufacturer_part_number = 54; */
        if (message.manufacturerPartNumber !== "")
            writer.tag(54, WireType.LengthDelimited).string(message.manufacturerPartNumber);
        /* string coupon_code = 55; */
        if (message.couponCode !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.couponCode);
        /* string coupon_tax = 56; */
        if (message.couponTax !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.couponTax);
        /* string fine_line_class_code = 57; */
        if (message.fineLineClassCode !== "")
            writer.tag(57, WireType.LengthDelimited).string(message.fineLineClassCode);
        /* string unit = 58; */
        if (message.unit !== "")
            writer.tag(58, WireType.LengthDelimited).string(message.unit);
        /* string substitute_item = 59; */
        if (message.substituteItem !== "")
            writer.tag(59, WireType.LengthDelimited).string(message.substituteItem);
        /* string master_image_url = 60; */
        if (message.masterImageUrl !== "")
            writer.tag(60, WireType.LengthDelimited).string(message.masterImageUrl);
        /* repeated string other_image_urls = 61; */
        for (let i = 0; i < message.otherImageUrls.length; i++)
            writer.tag(61, WireType.LengthDelimited).string(message.otherImageUrls[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.DoItBestCatalogItem
 */
export const DoItBestCatalogItem = new DoItBestCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrgillCatalogItem$Type extends MessageType<OrgillCatalogItem> {
    constructor() {
        super("rd.catalog.OrgillCatalogItem", [
            { no: 1, name: "break_pack_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "weight", kind: "message", T: () => Decimal },
            { no: 3, name: "division", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "suggested_retail", kind: "message", T: () => Money },
            { no: 5, name: "sell_price_1", kind: "message", T: () => Money },
            { no: 6, name: "vp1_cost", kind: "message", T: () => FractionalMoney },
            { no: 7, name: "vp2_cost", kind: "message", T: () => FractionalMoney },
            { no: 8, name: "adv_cost", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "retail_unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "retail_sensitivity_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "quantity_round_option", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "factory_pack_size", kind: "message", T: () => Decimal },
            { no: 13, name: "benchmark_pro", kind: "message", T: () => Money },
            { no: 14, name: "benchmark_retail", kind: "message", T: () => Money },
            { no: 15, name: "ic_master", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "ic_major", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "ic_sub_1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "retail_dept_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "retail_class_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "retail_sensitivity_code_numeric", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "harmonized_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "hazardous_air", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "hazardous_inland", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "hazardous_marine", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "ansi_selling_unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "ansi_retail_unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "record_change_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "velocity_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "minimum_order_quantity", kind: "message", T: () => Decimal },
            { no: 31, name: "buying_department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "report_group", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "selling_unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "retail_classification", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "vendor_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "factory_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "retail_conversion_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "retail_conversion_factor", kind: "message", T: () => Decimal },
            { no: 39, name: "shelf_pack", kind: "message", T: () => Decimal },
            { no: 40, name: "retail_unit_of_measure_extended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "pro_sensitivity_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "substitute_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "referral_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "large_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "small_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "vendor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 47, name: "model_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 48, name: "vendor_unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "selling_unit_pack_size", kind: "message", T: () => Decimal },
            { no: 50, name: "container_upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 51, name: "old_upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 52, name: "online_title_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 53, name: "online_long_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 54, name: "major_category_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 55, name: "master_category_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrgillCatalogItem>): OrgillCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.breakPackFlag = "";
        message.division = "";
        message.retailUnitOfMeasure = "";
        message.retailSensitivityCode = "";
        message.quantityRoundOption = "";
        message.icMaster = "";
        message.icMajor = "";
        message.icSub1 = "";
        message.retailDeptDescription = "";
        message.retailClassDescription = "";
        message.countryCode = "";
        message.retailSensitivityCodeNumeric = "";
        message.harmonizedCode = "";
        message.hazardousAir = false;
        message.hazardousInland = false;
        message.hazardousMarine = false;
        message.ansiSellingUnitOfMeasure = "";
        message.ansiRetailUnitOfMeasure = "";
        message.recordChangeFlag = "";
        message.velocityCode = "";
        message.buyingDepartment = "";
        message.reportGroup = "";
        message.sellingUnitOfMeasure = "";
        message.retailClassification = "";
        message.vendorNumber = "";
        message.factoryNumber = "";
        message.retailConversionFlag = "";
        message.retailUnitOfMeasureExtended = "";
        message.proSensitivityCode = "";
        message.substituteNumber = "";
        message.referralNumber = "";
        message.largeImageUrl = "";
        message.smallImageUrl = "";
        message.vendorName = "";
        message.modelNumber = "";
        message.vendorUnitOfMeasure = "";
        message.containerUpc = "";
        message.oldUpc = "";
        message.onlineTitleDescription = "";
        message.onlineLongDescription = "";
        message.majorCategoryName = "";
        message.masterCategoryName = "";
        if (value !== undefined)
            reflectionMergePartial<OrgillCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrgillCatalogItem): OrgillCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string break_pack_flag */ 1:
                    message.breakPackFlag = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal weight */ 2:
                    message.weight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* string division */ 3:
                    message.division = reader.string();
                    break;
                case /* rd.proto.money.Money suggested_retail */ 4:
                    message.suggestedRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedRetail);
                    break;
                case /* rd.proto.money.Money sell_price_1 */ 5:
                    message.sellPrice1 = Money.internalBinaryRead(reader, reader.uint32(), options, message.sellPrice1);
                    break;
                case /* rd.proto.money.FractionalMoney vp1_cost */ 6:
                    message.vp1Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.vp1Cost);
                    break;
                case /* rd.proto.money.FractionalMoney vp2_cost */ 7:
                    message.vp2Cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.vp2Cost);
                    break;
                case /* rd.proto.money.FractionalMoney adv_cost */ 8:
                    message.advCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.advCost);
                    break;
                case /* string retail_unit_of_measure */ 9:
                    message.retailUnitOfMeasure = reader.string();
                    break;
                case /* string retail_sensitivity_code */ 10:
                    message.retailSensitivityCode = reader.string();
                    break;
                case /* string quantity_round_option */ 11:
                    message.quantityRoundOption = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal factory_pack_size */ 12:
                    message.factoryPackSize = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.factoryPackSize);
                    break;
                case /* rd.proto.money.Money benchmark_pro */ 13:
                    message.benchmarkPro = Money.internalBinaryRead(reader, reader.uint32(), options, message.benchmarkPro);
                    break;
                case /* rd.proto.money.Money benchmark_retail */ 14:
                    message.benchmarkRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.benchmarkRetail);
                    break;
                case /* string ic_master */ 15:
                    message.icMaster = reader.string();
                    break;
                case /* string ic_major */ 16:
                    message.icMajor = reader.string();
                    break;
                case /* string ic_sub_1 */ 17:
                    message.icSub1 = reader.string();
                    break;
                case /* string retail_dept_description */ 18:
                    message.retailDeptDescription = reader.string();
                    break;
                case /* string retail_class_description */ 19:
                    message.retailClassDescription = reader.string();
                    break;
                case /* string country_code */ 20:
                    message.countryCode = reader.string();
                    break;
                case /* string retail_sensitivity_code_numeric */ 21:
                    message.retailSensitivityCodeNumeric = reader.string();
                    break;
                case /* string harmonized_code */ 22:
                    message.harmonizedCode = reader.string();
                    break;
                case /* bool hazardous_air */ 23:
                    message.hazardousAir = reader.bool();
                    break;
                case /* bool hazardous_inland */ 24:
                    message.hazardousInland = reader.bool();
                    break;
                case /* bool hazardous_marine */ 25:
                    message.hazardousMarine = reader.bool();
                    break;
                case /* string ansi_selling_unit_of_measure */ 26:
                    message.ansiSellingUnitOfMeasure = reader.string();
                    break;
                case /* string ansi_retail_unit_of_measure */ 27:
                    message.ansiRetailUnitOfMeasure = reader.string();
                    break;
                case /* string record_change_flag */ 28:
                    message.recordChangeFlag = reader.string();
                    break;
                case /* string velocity_code */ 29:
                    message.velocityCode = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal minimum_order_quantity */ 30:
                    message.minimumOrderQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.minimumOrderQuantity);
                    break;
                case /* string buying_department */ 31:
                    message.buyingDepartment = reader.string();
                    break;
                case /* string report_group */ 32:
                    message.reportGroup = reader.string();
                    break;
                case /* string selling_unit_of_measure */ 33:
                    message.sellingUnitOfMeasure = reader.string();
                    break;
                case /* string retail_classification */ 34:
                    message.retailClassification = reader.string();
                    break;
                case /* string vendor_number */ 35:
                    message.vendorNumber = reader.string();
                    break;
                case /* string factory_number */ 36:
                    message.factoryNumber = reader.string();
                    break;
                case /* string retail_conversion_flag */ 37:
                    message.retailConversionFlag = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal retail_conversion_factor */ 38:
                    message.retailConversionFactor = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailConversionFactor);
                    break;
                case /* rd.proto.decimal.Decimal shelf_pack */ 39:
                    message.shelfPack = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.shelfPack);
                    break;
                case /* string retail_unit_of_measure_extended */ 40:
                    message.retailUnitOfMeasureExtended = reader.string();
                    break;
                case /* string pro_sensitivity_code */ 41:
                    message.proSensitivityCode = reader.string();
                    break;
                case /* string substitute_number */ 42:
                    message.substituteNumber = reader.string();
                    break;
                case /* string referral_number */ 43:
                    message.referralNumber = reader.string();
                    break;
                case /* string large_image_url */ 44:
                    message.largeImageUrl = reader.string();
                    break;
                case /* string small_image_url */ 45:
                    message.smallImageUrl = reader.string();
                    break;
                case /* string vendor_name */ 46:
                    message.vendorName = reader.string();
                    break;
                case /* string model_number */ 47:
                    message.modelNumber = reader.string();
                    break;
                case /* string vendor_unit_of_measure */ 48:
                    message.vendorUnitOfMeasure = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal selling_unit_pack_size */ 49:
                    message.sellingUnitPackSize = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.sellingUnitPackSize);
                    break;
                case /* string container_upc */ 50:
                    message.containerUpc = reader.string();
                    break;
                case /* string old_upc */ 51:
                    message.oldUpc = reader.string();
                    break;
                case /* string online_title_description */ 52:
                    message.onlineTitleDescription = reader.string();
                    break;
                case /* string online_long_description */ 53:
                    message.onlineLongDescription = reader.string();
                    break;
                case /* string major_category_name */ 54:
                    message.majorCategoryName = reader.string();
                    break;
                case /* string master_category_name */ 55:
                    message.masterCategoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrgillCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string break_pack_flag = 1; */
        if (message.breakPackFlag !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.breakPackFlag);
        /* rd.proto.decimal.Decimal weight = 2; */
        if (message.weight)
            Decimal.internalBinaryWrite(message.weight, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string division = 3; */
        if (message.division !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.division);
        /* rd.proto.money.Money suggested_retail = 4; */
        if (message.suggestedRetail)
            Money.internalBinaryWrite(message.suggestedRetail, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sell_price_1 = 5; */
        if (message.sellPrice1)
            Money.internalBinaryWrite(message.sellPrice1, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney vp1_cost = 6; */
        if (message.vp1Cost)
            FractionalMoney.internalBinaryWrite(message.vp1Cost, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney vp2_cost = 7; */
        if (message.vp2Cost)
            FractionalMoney.internalBinaryWrite(message.vp2Cost, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney adv_cost = 8; */
        if (message.advCost)
            FractionalMoney.internalBinaryWrite(message.advCost, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string retail_unit_of_measure = 9; */
        if (message.retailUnitOfMeasure !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.retailUnitOfMeasure);
        /* string retail_sensitivity_code = 10; */
        if (message.retailSensitivityCode !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.retailSensitivityCode);
        /* string quantity_round_option = 11; */
        if (message.quantityRoundOption !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.quantityRoundOption);
        /* rd.proto.decimal.Decimal factory_pack_size = 12; */
        if (message.factoryPackSize)
            Decimal.internalBinaryWrite(message.factoryPackSize, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money benchmark_pro = 13; */
        if (message.benchmarkPro)
            Money.internalBinaryWrite(message.benchmarkPro, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money benchmark_retail = 14; */
        if (message.benchmarkRetail)
            Money.internalBinaryWrite(message.benchmarkRetail, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string ic_master = 15; */
        if (message.icMaster !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.icMaster);
        /* string ic_major = 16; */
        if (message.icMajor !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.icMajor);
        /* string ic_sub_1 = 17; */
        if (message.icSub1 !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.icSub1);
        /* string retail_dept_description = 18; */
        if (message.retailDeptDescription !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.retailDeptDescription);
        /* string retail_class_description = 19; */
        if (message.retailClassDescription !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.retailClassDescription);
        /* string country_code = 20; */
        if (message.countryCode !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.countryCode);
        /* string retail_sensitivity_code_numeric = 21; */
        if (message.retailSensitivityCodeNumeric !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.retailSensitivityCodeNumeric);
        /* string harmonized_code = 22; */
        if (message.harmonizedCode !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.harmonizedCode);
        /* bool hazardous_air = 23; */
        if (message.hazardousAir !== false)
            writer.tag(23, WireType.Varint).bool(message.hazardousAir);
        /* bool hazardous_inland = 24; */
        if (message.hazardousInland !== false)
            writer.tag(24, WireType.Varint).bool(message.hazardousInland);
        /* bool hazardous_marine = 25; */
        if (message.hazardousMarine !== false)
            writer.tag(25, WireType.Varint).bool(message.hazardousMarine);
        /* string ansi_selling_unit_of_measure = 26; */
        if (message.ansiSellingUnitOfMeasure !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.ansiSellingUnitOfMeasure);
        /* string ansi_retail_unit_of_measure = 27; */
        if (message.ansiRetailUnitOfMeasure !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.ansiRetailUnitOfMeasure);
        /* string record_change_flag = 28; */
        if (message.recordChangeFlag !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.recordChangeFlag);
        /* string velocity_code = 29; */
        if (message.velocityCode !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.velocityCode);
        /* rd.proto.decimal.Decimal minimum_order_quantity = 30; */
        if (message.minimumOrderQuantity)
            Decimal.internalBinaryWrite(message.minimumOrderQuantity, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* string buying_department = 31; */
        if (message.buyingDepartment !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.buyingDepartment);
        /* string report_group = 32; */
        if (message.reportGroup !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.reportGroup);
        /* string selling_unit_of_measure = 33; */
        if (message.sellingUnitOfMeasure !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.sellingUnitOfMeasure);
        /* string retail_classification = 34; */
        if (message.retailClassification !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.retailClassification);
        /* string vendor_number = 35; */
        if (message.vendorNumber !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.vendorNumber);
        /* string factory_number = 36; */
        if (message.factoryNumber !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.factoryNumber);
        /* string retail_conversion_flag = 37; */
        if (message.retailConversionFlag !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.retailConversionFlag);
        /* rd.proto.decimal.Decimal retail_conversion_factor = 38; */
        if (message.retailConversionFactor)
            Decimal.internalBinaryWrite(message.retailConversionFactor, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal shelf_pack = 39; */
        if (message.shelfPack)
            Decimal.internalBinaryWrite(message.shelfPack, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* string retail_unit_of_measure_extended = 40; */
        if (message.retailUnitOfMeasureExtended !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.retailUnitOfMeasureExtended);
        /* string pro_sensitivity_code = 41; */
        if (message.proSensitivityCode !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.proSensitivityCode);
        /* string substitute_number = 42; */
        if (message.substituteNumber !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.substituteNumber);
        /* string referral_number = 43; */
        if (message.referralNumber !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.referralNumber);
        /* string large_image_url = 44; */
        if (message.largeImageUrl !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.largeImageUrl);
        /* string small_image_url = 45; */
        if (message.smallImageUrl !== "")
            writer.tag(45, WireType.LengthDelimited).string(message.smallImageUrl);
        /* string vendor_name = 46; */
        if (message.vendorName !== "")
            writer.tag(46, WireType.LengthDelimited).string(message.vendorName);
        /* string model_number = 47; */
        if (message.modelNumber !== "")
            writer.tag(47, WireType.LengthDelimited).string(message.modelNumber);
        /* string vendor_unit_of_measure = 48; */
        if (message.vendorUnitOfMeasure !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.vendorUnitOfMeasure);
        /* rd.proto.decimal.Decimal selling_unit_pack_size = 49; */
        if (message.sellingUnitPackSize)
            Decimal.internalBinaryWrite(message.sellingUnitPackSize, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* string container_upc = 50; */
        if (message.containerUpc !== "")
            writer.tag(50, WireType.LengthDelimited).string(message.containerUpc);
        /* string old_upc = 51; */
        if (message.oldUpc !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.oldUpc);
        /* string online_title_description = 52; */
        if (message.onlineTitleDescription !== "")
            writer.tag(52, WireType.LengthDelimited).string(message.onlineTitleDescription);
        /* string online_long_description = 53; */
        if (message.onlineLongDescription !== "")
            writer.tag(53, WireType.LengthDelimited).string(message.onlineLongDescription);
        /* string major_category_name = 54; */
        if (message.majorCategoryName !== "")
            writer.tag(54, WireType.LengthDelimited).string(message.majorCategoryName);
        /* string master_category_name = 55; */
        if (message.masterCategoryName !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.masterCategoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.OrgillCatalogItem
 */
export const OrgillCatalogItem = new OrgillCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TrueValueCatalogItem$Type extends MessageType<TrueValueCatalogItem> {
    constructor() {
        super("rd.catalog.TrueValueCatalogItem", [
            { no: 52, name: "member_cost_tier_1", kind: "message", T: () => FractionalMoney },
            { no: 53, name: "tier_1_quantity", kind: "message", T: () => Decimal },
            { no: 1, name: "member_cost_tier_2", kind: "message", T: () => FractionalMoney },
            { no: 2, name: "tier_2_quantity", kind: "message", T: () => Decimal },
            { no: 3, name: "member_cost_tier_3", kind: "message", T: () => FractionalMoney },
            { no: 4, name: "tier_3_quantity", kind: "message", T: () => Decimal },
            { no: 5, name: "member_cost_tier_4", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "tier_4_quantity", kind: "message", T: () => Decimal },
            { no: 54, name: "suggested_retail_price", kind: "message", T: () => Money },
            { no: 55, name: "model_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 58, name: "multiplier", kind: "message", T: () => Decimal },
            { no: 7, name: "variable_retail_price", kind: "message", T: () => Money },
            { no: 8, name: "variable_price_method_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "wholesale_variable_retail_price", kind: "message", T: () => Money },
            { no: 10, name: "wholesale_variable_price_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "fractional_variable_retail_price", kind: "message", T: () => Money },
            { no: 12, name: "fractional_variable_price_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "wholesale_suggested_retail", kind: "message", T: () => Money },
            { no: 14, name: "wholesale_sr_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "vendor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "buy_dept", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "fineline_dept", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 56, name: "fineline_class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "fineline_subclass", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "retail_page", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "exclusive_brand_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "planogram", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "policy_a", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "dated_merch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "retail_assortment_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "core_indicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "green_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "tiered_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "visibility_flag_edlp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "made_in_usa", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "central_ship_indicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "non_stocked_sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "break_pack", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 57, name: "broken_carton_chrg", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "weight", kind: "message", T: () => Decimal },
            { no: 34, name: "length", kind: "message", T: () => Decimal },
            { no: 35, name: "width", kind: "message", T: () => Decimal },
            { no: 36, name: "height", kind: "message", T: () => Decimal },
            { no: 37, name: "shelf_weight", kind: "message", T: () => Decimal },
            { no: 38, name: "shelf_length", kind: "message", T: () => Decimal },
            { no: 39, name: "shelf_width", kind: "message", T: () => Decimal },
            { no: 40, name: "shelf_height", kind: "message", T: () => Decimal },
            { no: 41, name: "coupon_source", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "coupon_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "image_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "to_be_discontinued_date", kind: "message", T: () => Timestamp },
            { no: 45, name: "discontinued_date", kind: "message", T: () => Timestamp },
            { no: 46, name: "date_added", kind: "message", T: () => Timestamp },
            { no: 50, name: "to_be_discontinued_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 51, name: "discontinued_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 47, name: "substitute_item_type_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 48, name: "discontinue_reason_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "update_indicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 59, name: "substitute_referral_item_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 60, name: "retail_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TrueValueCatalogItem>): TrueValueCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.modelNumber = "";
        message.variablePriceMethodCode = "";
        message.wholesaleVariablePriceUom = "";
        message.fractionalVariablePriceUom = "";
        message.wholesaleSrUom = "";
        message.vendorName = "";
        message.buyDept = "";
        message.finelineDept = "";
        message.finelineClass = "";
        message.finelineSubclass = "";
        message.retailPage = "";
        message.exclusiveBrandCode = "";
        message.planogram = "";
        message.policyA = "";
        message.datedMerch = "";
        message.retailAssortmentCode = "";
        message.coreIndicator = "";
        message.greenItem = "";
        message.tieredItem = "";
        message.visibilityFlagEdlp = "";
        message.madeInUsa = "";
        message.centralShipIndicator = "";
        message.nonStockedSku = "";
        message.breakPack = "";
        message.brokenCartonChrg = "";
        message.couponSource = "";
        message.couponType = "";
        message.imageId = "";
        message.toBeDiscontinuedFlag = "";
        message.discontinuedFlag = "";
        message.substituteItemTypeCode = "";
        message.discontinueReasonCode = "";
        message.updateIndicator = "";
        message.substituteReferralItemNumber = "";
        message.retailUom = "";
        if (value !== undefined)
            reflectionMergePartial<TrueValueCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TrueValueCatalogItem): TrueValueCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.FractionalMoney member_cost_tier_1 */ 52:
                    message.memberCostTier1 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.memberCostTier1);
                    break;
                case /* rd.proto.decimal.Decimal tier_1_quantity */ 53:
                    message.tier1Quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.tier1Quantity);
                    break;
                case /* rd.proto.money.FractionalMoney member_cost_tier_2 */ 1:
                    message.memberCostTier2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.memberCostTier2);
                    break;
                case /* rd.proto.decimal.Decimal tier_2_quantity */ 2:
                    message.tier2Quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.tier2Quantity);
                    break;
                case /* rd.proto.money.FractionalMoney member_cost_tier_3 */ 3:
                    message.memberCostTier3 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.memberCostTier3);
                    break;
                case /* rd.proto.decimal.Decimal tier_3_quantity */ 4:
                    message.tier3Quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.tier3Quantity);
                    break;
                case /* rd.proto.money.FractionalMoney member_cost_tier_4 */ 5:
                    message.memberCostTier4 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.memberCostTier4);
                    break;
                case /* rd.proto.decimal.Decimal tier_4_quantity */ 6:
                    message.tier4Quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.tier4Quantity);
                    break;
                case /* rd.proto.money.Money suggested_retail_price */ 54:
                    message.suggestedRetailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedRetailPrice);
                    break;
                case /* string model_number */ 55:
                    message.modelNumber = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal multiplier */ 58:
                    message.multiplier = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.multiplier);
                    break;
                case /* rd.proto.money.Money variable_retail_price */ 7:
                    message.variableRetailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.variableRetailPrice);
                    break;
                case /* string variable_price_method_code */ 8:
                    message.variablePriceMethodCode = reader.string();
                    break;
                case /* rd.proto.money.Money wholesale_variable_retail_price */ 9:
                    message.wholesaleVariableRetailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.wholesaleVariableRetailPrice);
                    break;
                case /* string wholesale_variable_price_uom */ 10:
                    message.wholesaleVariablePriceUom = reader.string();
                    break;
                case /* rd.proto.money.Money fractional_variable_retail_price */ 11:
                    message.fractionalVariableRetailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.fractionalVariableRetailPrice);
                    break;
                case /* string fractional_variable_price_uom */ 12:
                    message.fractionalVariablePriceUom = reader.string();
                    break;
                case /* rd.proto.money.Money wholesale_suggested_retail */ 13:
                    message.wholesaleSuggestedRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.wholesaleSuggestedRetail);
                    break;
                case /* string wholesale_sr_uom */ 14:
                    message.wholesaleSrUom = reader.string();
                    break;
                case /* string vendor_name */ 15:
                    message.vendorName = reader.string();
                    break;
                case /* string buy_dept */ 16:
                    message.buyDept = reader.string();
                    break;
                case /* string fineline_dept */ 17:
                    message.finelineDept = reader.string();
                    break;
                case /* string fineline_class */ 56:
                    message.finelineClass = reader.string();
                    break;
                case /* string fineline_subclass */ 18:
                    message.finelineSubclass = reader.string();
                    break;
                case /* string retail_page */ 19:
                    message.retailPage = reader.string();
                    break;
                case /* string exclusive_brand_code */ 20:
                    message.exclusiveBrandCode = reader.string();
                    break;
                case /* string planogram */ 21:
                    message.planogram = reader.string();
                    break;
                case /* string policy_a */ 22:
                    message.policyA = reader.string();
                    break;
                case /* string dated_merch */ 23:
                    message.datedMerch = reader.string();
                    break;
                case /* string retail_assortment_code */ 24:
                    message.retailAssortmentCode = reader.string();
                    break;
                case /* string core_indicator */ 25:
                    message.coreIndicator = reader.string();
                    break;
                case /* string green_item */ 26:
                    message.greenItem = reader.string();
                    break;
                case /* string tiered_item */ 27:
                    message.tieredItem = reader.string();
                    break;
                case /* string visibility_flag_edlp */ 28:
                    message.visibilityFlagEdlp = reader.string();
                    break;
                case /* string made_in_usa */ 29:
                    message.madeInUsa = reader.string();
                    break;
                case /* string central_ship_indicator */ 30:
                    message.centralShipIndicator = reader.string();
                    break;
                case /* string non_stocked_sku */ 31:
                    message.nonStockedSku = reader.string();
                    break;
                case /* string break_pack */ 32:
                    message.breakPack = reader.string();
                    break;
                case /* string broken_carton_chrg */ 57:
                    message.brokenCartonChrg = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal weight */ 33:
                    message.weight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* rd.proto.decimal.Decimal length */ 34:
                    message.length = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.length);
                    break;
                case /* rd.proto.decimal.Decimal width */ 35:
                    message.width = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.width);
                    break;
                case /* rd.proto.decimal.Decimal height */ 36:
                    message.height = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                case /* rd.proto.decimal.Decimal shelf_weight */ 37:
                    message.shelfWeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.shelfWeight);
                    break;
                case /* rd.proto.decimal.Decimal shelf_length */ 38:
                    message.shelfLength = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.shelfLength);
                    break;
                case /* rd.proto.decimal.Decimal shelf_width */ 39:
                    message.shelfWidth = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.shelfWidth);
                    break;
                case /* rd.proto.decimal.Decimal shelf_height */ 40:
                    message.shelfHeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.shelfHeight);
                    break;
                case /* string coupon_source */ 41:
                    message.couponSource = reader.string();
                    break;
                case /* string coupon_type */ 42:
                    message.couponType = reader.string();
                    break;
                case /* string image_id */ 43:
                    message.imageId = reader.string();
                    break;
                case /* google.protobuf.Timestamp to_be_discontinued_date */ 44:
                    message.toBeDiscontinuedDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.toBeDiscontinuedDate);
                    break;
                case /* google.protobuf.Timestamp discontinued_date */ 45:
                    message.discontinuedDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.discontinuedDate);
                    break;
                case /* google.protobuf.Timestamp date_added */ 46:
                    message.dateAdded = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dateAdded);
                    break;
                case /* string to_be_discontinued_flag */ 50:
                    message.toBeDiscontinuedFlag = reader.string();
                    break;
                case /* string discontinued_flag */ 51:
                    message.discontinuedFlag = reader.string();
                    break;
                case /* string substitute_item_type_code */ 47:
                    message.substituteItemTypeCode = reader.string();
                    break;
                case /* string discontinue_reason_code */ 48:
                    message.discontinueReasonCode = reader.string();
                    break;
                case /* string update_indicator */ 49:
                    message.updateIndicator = reader.string();
                    break;
                case /* string substitute_referral_item_number */ 59:
                    message.substituteReferralItemNumber = reader.string();
                    break;
                case /* string retail_uom */ 60:
                    message.retailUom = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TrueValueCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.FractionalMoney member_cost_tier_2 = 1; */
        if (message.memberCostTier2)
            FractionalMoney.internalBinaryWrite(message.memberCostTier2, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal tier_2_quantity = 2; */
        if (message.tier2Quantity)
            Decimal.internalBinaryWrite(message.tier2Quantity, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney member_cost_tier_3 = 3; */
        if (message.memberCostTier3)
            FractionalMoney.internalBinaryWrite(message.memberCostTier3, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal tier_3_quantity = 4; */
        if (message.tier3Quantity)
            Decimal.internalBinaryWrite(message.tier3Quantity, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney member_cost_tier_4 = 5; */
        if (message.memberCostTier4)
            FractionalMoney.internalBinaryWrite(message.memberCostTier4, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal tier_4_quantity = 6; */
        if (message.tier4Quantity)
            Decimal.internalBinaryWrite(message.tier4Quantity, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money variable_retail_price = 7; */
        if (message.variableRetailPrice)
            Money.internalBinaryWrite(message.variableRetailPrice, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string variable_price_method_code = 8; */
        if (message.variablePriceMethodCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.variablePriceMethodCode);
        /* rd.proto.money.Money wholesale_variable_retail_price = 9; */
        if (message.wholesaleVariableRetailPrice)
            Money.internalBinaryWrite(message.wholesaleVariableRetailPrice, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string wholesale_variable_price_uom = 10; */
        if (message.wholesaleVariablePriceUom !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.wholesaleVariablePriceUom);
        /* rd.proto.money.Money fractional_variable_retail_price = 11; */
        if (message.fractionalVariableRetailPrice)
            Money.internalBinaryWrite(message.fractionalVariableRetailPrice, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string fractional_variable_price_uom = 12; */
        if (message.fractionalVariablePriceUom !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.fractionalVariablePriceUom);
        /* rd.proto.money.Money wholesale_suggested_retail = 13; */
        if (message.wholesaleSuggestedRetail)
            Money.internalBinaryWrite(message.wholesaleSuggestedRetail, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string wholesale_sr_uom = 14; */
        if (message.wholesaleSrUom !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.wholesaleSrUom);
        /* string vendor_name = 15; */
        if (message.vendorName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.vendorName);
        /* string buy_dept = 16; */
        if (message.buyDept !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.buyDept);
        /* string fineline_dept = 17; */
        if (message.finelineDept !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.finelineDept);
        /* string fineline_subclass = 18; */
        if (message.finelineSubclass !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.finelineSubclass);
        /* string retail_page = 19; */
        if (message.retailPage !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.retailPage);
        /* string exclusive_brand_code = 20; */
        if (message.exclusiveBrandCode !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.exclusiveBrandCode);
        /* string planogram = 21; */
        if (message.planogram !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.planogram);
        /* string policy_a = 22; */
        if (message.policyA !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.policyA);
        /* string dated_merch = 23; */
        if (message.datedMerch !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.datedMerch);
        /* string retail_assortment_code = 24; */
        if (message.retailAssortmentCode !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.retailAssortmentCode);
        /* string core_indicator = 25; */
        if (message.coreIndicator !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.coreIndicator);
        /* string green_item = 26; */
        if (message.greenItem !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.greenItem);
        /* string tiered_item = 27; */
        if (message.tieredItem !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.tieredItem);
        /* string visibility_flag_edlp = 28; */
        if (message.visibilityFlagEdlp !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.visibilityFlagEdlp);
        /* string made_in_usa = 29; */
        if (message.madeInUsa !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.madeInUsa);
        /* string central_ship_indicator = 30; */
        if (message.centralShipIndicator !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.centralShipIndicator);
        /* string non_stocked_sku = 31; */
        if (message.nonStockedSku !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.nonStockedSku);
        /* string break_pack = 32; */
        if (message.breakPack !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.breakPack);
        /* rd.proto.decimal.Decimal weight = 33; */
        if (message.weight)
            Decimal.internalBinaryWrite(message.weight, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal length = 34; */
        if (message.length)
            Decimal.internalBinaryWrite(message.length, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal width = 35; */
        if (message.width)
            Decimal.internalBinaryWrite(message.width, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal height = 36; */
        if (message.height)
            Decimal.internalBinaryWrite(message.height, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal shelf_weight = 37; */
        if (message.shelfWeight)
            Decimal.internalBinaryWrite(message.shelfWeight, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal shelf_length = 38; */
        if (message.shelfLength)
            Decimal.internalBinaryWrite(message.shelfLength, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal shelf_width = 39; */
        if (message.shelfWidth)
            Decimal.internalBinaryWrite(message.shelfWidth, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal shelf_height = 40; */
        if (message.shelfHeight)
            Decimal.internalBinaryWrite(message.shelfHeight, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* string coupon_source = 41; */
        if (message.couponSource !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.couponSource);
        /* string coupon_type = 42; */
        if (message.couponType !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.couponType);
        /* string image_id = 43; */
        if (message.imageId !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.imageId);
        /* google.protobuf.Timestamp to_be_discontinued_date = 44; */
        if (message.toBeDiscontinuedDate)
            Timestamp.internalBinaryWrite(message.toBeDiscontinuedDate, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp discontinued_date = 45; */
        if (message.discontinuedDate)
            Timestamp.internalBinaryWrite(message.discontinuedDate, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp date_added = 46; */
        if (message.dateAdded)
            Timestamp.internalBinaryWrite(message.dateAdded, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* string substitute_item_type_code = 47; */
        if (message.substituteItemTypeCode !== "")
            writer.tag(47, WireType.LengthDelimited).string(message.substituteItemTypeCode);
        /* string discontinue_reason_code = 48; */
        if (message.discontinueReasonCode !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.discontinueReasonCode);
        /* string update_indicator = 49; */
        if (message.updateIndicator !== "")
            writer.tag(49, WireType.LengthDelimited).string(message.updateIndicator);
        /* string to_be_discontinued_flag = 50; */
        if (message.toBeDiscontinuedFlag !== "")
            writer.tag(50, WireType.LengthDelimited).string(message.toBeDiscontinuedFlag);
        /* string discontinued_flag = 51; */
        if (message.discontinuedFlag !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.discontinuedFlag);
        /* rd.proto.money.FractionalMoney member_cost_tier_1 = 52; */
        if (message.memberCostTier1)
            FractionalMoney.internalBinaryWrite(message.memberCostTier1, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal tier_1_quantity = 53; */
        if (message.tier1Quantity)
            Decimal.internalBinaryWrite(message.tier1Quantity, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money suggested_retail_price = 54; */
        if (message.suggestedRetailPrice)
            Money.internalBinaryWrite(message.suggestedRetailPrice, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* string model_number = 55; */
        if (message.modelNumber !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.modelNumber);
        /* string fineline_class = 56; */
        if (message.finelineClass !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.finelineClass);
        /* string broken_carton_chrg = 57; */
        if (message.brokenCartonChrg !== "")
            writer.tag(57, WireType.LengthDelimited).string(message.brokenCartonChrg);
        /* rd.proto.decimal.Decimal multiplier = 58; */
        if (message.multiplier)
            Decimal.internalBinaryWrite(message.multiplier, writer.tag(58, WireType.LengthDelimited).fork(), options).join();
        /* string substitute_referral_item_number = 59; */
        if (message.substituteReferralItemNumber !== "")
            writer.tag(59, WireType.LengthDelimited).string(message.substituteReferralItemNumber);
        /* string retail_uom = 60; */
        if (message.retailUom !== "")
            writer.tag(60, WireType.LengthDelimited).string(message.retailUom);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.TrueValueCatalogItem
 */
export const TrueValueCatalogItem = new TrueValueCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmeryJensenCatalogItem$Type extends MessageType<EmeryJensenCatalogItem> {
    constructor() {
        super("rd.catalog.EmeryJensenCatalogItem", [
            { no: 1, name: "ace_retail_amount", kind: "message", T: () => Money },
            { no: 2, name: "regular_retail_amount", kind: "message", T: () => Money },
            { no: 3, name: "level_1_retail_amount", kind: "message", T: () => Money },
            { no: 4, name: "level_2_retail_amount", kind: "message", T: () => Money },
            { no: 5, name: "mru_retail_amount", kind: "message", T: () => Money },
            { no: 6, name: "retail_store_prc", kind: "message", T: () => Money },
            { no: 7, name: "product_source_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "rsc_rdc_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "com_group", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "merchandise_class_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "price_strategy_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "product_group_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "product_def_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "vendor_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "manufacturer_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "brand_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "minimum_order_quantity", kind: "message", T: () => Decimal },
            { no: 18, name: "retail_units_quantity", kind: "message", T: () => Decimal },
            { no: 19, name: "retail_unit_dom_quantity", kind: "message", T: () => Decimal },
            { no: 20, name: "consumer_unit_quantity", kind: "message", T: () => Decimal },
            { no: 21, name: "consumer_unit_of_measure_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "shelf_sequence", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "exp_fmt_disc_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "conv_fmt_disc_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "core_fmt_disc_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "super_fmt_disc_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "plano_other_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "item_weight_quantity", kind: "message", T: () => Decimal },
            { no: 29, name: "each_length", kind: "message", T: () => Decimal },
            { no: 30, name: "each_width", kind: "message", T: () => Decimal },
            { no: 31, name: "each_height", kind: "message", T: () => Decimal },
            { no: 32, name: "each_volume", kind: "message", T: () => Decimal },
            { no: 33, name: "case_pack_length", kind: "message", T: () => Decimal },
            { no: 34, name: "case_pack_width", kind: "message", T: () => Decimal },
            { no: 35, name: "case_pack_height", kind: "message", T: () => Decimal },
            { no: 36, name: "case_pack_weight", kind: "message", T: () => Decimal },
            { no: 37, name: "case_pack_volume", kind: "message", T: () => Decimal },
            { no: 38, name: "item_status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "change_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "central_warehouse_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "central_warehouse_change_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "checklist_page", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "data_type_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 44, name: "def_goods_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "stock_expire_rec_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "retrieve_level_department_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 47, name: "stock_item_department", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 48, name: "replenishable_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 49, name: "b2b_flag", kind: "scalar", jsonName: "b2bFlag", T: 9 /*ScalarType.STRING*/ },
            { no: 50, name: "replenishment_stock_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 51, name: "warranty_regulation_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 61, name: "dealer_cost", kind: "message", T: () => FractionalMoney },
            { no: 52, name: "new_dealer_cost", kind: "message", T: () => FractionalMoney },
            { no: 53, name: "new_valid_from_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 54, name: "url_pic", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 55, name: "url_thumb", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 56, name: "selling_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 57, name: "order_multiple_quantity", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<EmeryJensenCatalogItem>): EmeryJensenCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productSourceCode = "";
        message.rscRdcCode = "";
        message.comGroup = "";
        message.merchandiseClassNumber = 0;
        message.priceStrategyCode = "";
        message.productGroupCode = "";
        message.productDefCode = "";
        message.vendorNumber = "";
        message.manufacturerNumber = "";
        message.brandName = "";
        message.consumerUnitOfMeasureCode = "";
        message.shelfSequence = "";
        message.expFmtDiscFlag = "";
        message.convFmtDiscFlag = "";
        message.coreFmtDiscFlag = "";
        message.superFmtDiscFlag = "";
        message.planoOtherFlag = "";
        message.itemStatusCode = "";
        message.changeCode = "";
        message.centralWarehouseCode = "";
        message.centralWarehouseChangeFlag = "";
        message.checklistPage = "";
        message.dataTypeCode = "";
        message.defGoodsCode = "";
        message.stockExpireRecCode = "";
        message.retrieveLevelDepartmentCode = "";
        message.stockItemDepartment = 0;
        message.replenishableFlag = "";
        message.b2BFlag = "";
        message.replenishmentStockNumber = "";
        message.warrantyRegulationCode = "";
        message.newValidFromDate = "";
        message.urlPic = "";
        message.urlThumb = "";
        message.sellingUom = "";
        if (value !== undefined)
            reflectionMergePartial<EmeryJensenCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmeryJensenCatalogItem): EmeryJensenCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money ace_retail_amount */ 1:
                    message.aceRetailAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.aceRetailAmount);
                    break;
                case /* rd.proto.money.Money regular_retail_amount */ 2:
                    message.regularRetailAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.regularRetailAmount);
                    break;
                case /* rd.proto.money.Money level_1_retail_amount */ 3:
                    message.level1RetailAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.level1RetailAmount);
                    break;
                case /* rd.proto.money.Money level_2_retail_amount */ 4:
                    message.level2RetailAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.level2RetailAmount);
                    break;
                case /* rd.proto.money.Money mru_retail_amount */ 5:
                    message.mruRetailAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.mruRetailAmount);
                    break;
                case /* rd.proto.money.Money retail_store_prc */ 6:
                    message.retailStorePrc = Money.internalBinaryRead(reader, reader.uint32(), options, message.retailStorePrc);
                    break;
                case /* string product_source_code */ 7:
                    message.productSourceCode = reader.string();
                    break;
                case /* string rsc_rdc_code */ 8:
                    message.rscRdcCode = reader.string();
                    break;
                case /* string com_group */ 9:
                    message.comGroup = reader.string();
                    break;
                case /* int32 merchandise_class_number */ 10:
                    message.merchandiseClassNumber = reader.int32();
                    break;
                case /* string price_strategy_code */ 11:
                    message.priceStrategyCode = reader.string();
                    break;
                case /* string product_group_code */ 12:
                    message.productGroupCode = reader.string();
                    break;
                case /* string product_def_code */ 13:
                    message.productDefCode = reader.string();
                    break;
                case /* string vendor_number */ 14:
                    message.vendorNumber = reader.string();
                    break;
                case /* string manufacturer_number */ 15:
                    message.manufacturerNumber = reader.string();
                    break;
                case /* string brand_name */ 16:
                    message.brandName = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal minimum_order_quantity */ 17:
                    message.minimumOrderQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.minimumOrderQuantity);
                    break;
                case /* rd.proto.decimal.Decimal retail_units_quantity */ 18:
                    message.retailUnitsQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailUnitsQuantity);
                    break;
                case /* rd.proto.decimal.Decimal retail_unit_dom_quantity */ 19:
                    message.retailUnitDomQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailUnitDomQuantity);
                    break;
                case /* rd.proto.decimal.Decimal consumer_unit_quantity */ 20:
                    message.consumerUnitQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.consumerUnitQuantity);
                    break;
                case /* string consumer_unit_of_measure_code */ 21:
                    message.consumerUnitOfMeasureCode = reader.string();
                    break;
                case /* string shelf_sequence */ 22:
                    message.shelfSequence = reader.string();
                    break;
                case /* string exp_fmt_disc_flag */ 23:
                    message.expFmtDiscFlag = reader.string();
                    break;
                case /* string conv_fmt_disc_flag */ 24:
                    message.convFmtDiscFlag = reader.string();
                    break;
                case /* string core_fmt_disc_flag */ 25:
                    message.coreFmtDiscFlag = reader.string();
                    break;
                case /* string super_fmt_disc_flag */ 26:
                    message.superFmtDiscFlag = reader.string();
                    break;
                case /* string plano_other_flag */ 27:
                    message.planoOtherFlag = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal item_weight_quantity */ 28:
                    message.itemWeightQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.itemWeightQuantity);
                    break;
                case /* rd.proto.decimal.Decimal each_length */ 29:
                    message.eachLength = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.eachLength);
                    break;
                case /* rd.proto.decimal.Decimal each_width */ 30:
                    message.eachWidth = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.eachWidth);
                    break;
                case /* rd.proto.decimal.Decimal each_height */ 31:
                    message.eachHeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.eachHeight);
                    break;
                case /* rd.proto.decimal.Decimal each_volume */ 32:
                    message.eachVolume = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.eachVolume);
                    break;
                case /* rd.proto.decimal.Decimal case_pack_length */ 33:
                    message.casePackLength = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.casePackLength);
                    break;
                case /* rd.proto.decimal.Decimal case_pack_width */ 34:
                    message.casePackWidth = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.casePackWidth);
                    break;
                case /* rd.proto.decimal.Decimal case_pack_height */ 35:
                    message.casePackHeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.casePackHeight);
                    break;
                case /* rd.proto.decimal.Decimal case_pack_weight */ 36:
                    message.casePackWeight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.casePackWeight);
                    break;
                case /* rd.proto.decimal.Decimal case_pack_volume */ 37:
                    message.casePackVolume = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.casePackVolume);
                    break;
                case /* string item_status_code */ 38:
                    message.itemStatusCode = reader.string();
                    break;
                case /* string change_code */ 39:
                    message.changeCode = reader.string();
                    break;
                case /* string central_warehouse_code */ 40:
                    message.centralWarehouseCode = reader.string();
                    break;
                case /* string central_warehouse_change_flag */ 41:
                    message.centralWarehouseChangeFlag = reader.string();
                    break;
                case /* string checklist_page */ 42:
                    message.checklistPage = reader.string();
                    break;
                case /* string data_type_code */ 43:
                    message.dataTypeCode = reader.string();
                    break;
                case /* string def_goods_code */ 44:
                    message.defGoodsCode = reader.string();
                    break;
                case /* string stock_expire_rec_code */ 45:
                    message.stockExpireRecCode = reader.string();
                    break;
                case /* string retrieve_level_department_code */ 46:
                    message.retrieveLevelDepartmentCode = reader.string();
                    break;
                case /* int32 stock_item_department */ 47:
                    message.stockItemDepartment = reader.int32();
                    break;
                case /* string replenishable_flag */ 48:
                    message.replenishableFlag = reader.string();
                    break;
                case /* string b2b_flag */ 49:
                    message.b2BFlag = reader.string();
                    break;
                case /* string replenishment_stock_number */ 50:
                    message.replenishmentStockNumber = reader.string();
                    break;
                case /* string warranty_regulation_code */ 51:
                    message.warrantyRegulationCode = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney dealer_cost */ 61:
                    message.dealerCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.dealerCost);
                    break;
                case /* rd.proto.money.FractionalMoney new_dealer_cost */ 52:
                    message.newDealerCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.newDealerCost);
                    break;
                case /* string new_valid_from_date */ 53:
                    message.newValidFromDate = reader.string();
                    break;
                case /* string url_pic */ 54:
                    message.urlPic = reader.string();
                    break;
                case /* string url_thumb */ 55:
                    message.urlThumb = reader.string();
                    break;
                case /* string selling_uom */ 56:
                    message.sellingUom = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal order_multiple_quantity */ 57:
                    message.orderMultipleQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.orderMultipleQuantity);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmeryJensenCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money ace_retail_amount = 1; */
        if (message.aceRetailAmount)
            Money.internalBinaryWrite(message.aceRetailAmount, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money regular_retail_amount = 2; */
        if (message.regularRetailAmount)
            Money.internalBinaryWrite(message.regularRetailAmount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money level_1_retail_amount = 3; */
        if (message.level1RetailAmount)
            Money.internalBinaryWrite(message.level1RetailAmount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money level_2_retail_amount = 4; */
        if (message.level2RetailAmount)
            Money.internalBinaryWrite(message.level2RetailAmount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money mru_retail_amount = 5; */
        if (message.mruRetailAmount)
            Money.internalBinaryWrite(message.mruRetailAmount, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money retail_store_prc = 6; */
        if (message.retailStorePrc)
            Money.internalBinaryWrite(message.retailStorePrc, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string product_source_code = 7; */
        if (message.productSourceCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.productSourceCode);
        /* string rsc_rdc_code = 8; */
        if (message.rscRdcCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.rscRdcCode);
        /* string com_group = 9; */
        if (message.comGroup !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.comGroup);
        /* int32 merchandise_class_number = 10; */
        if (message.merchandiseClassNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.merchandiseClassNumber);
        /* string price_strategy_code = 11; */
        if (message.priceStrategyCode !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.priceStrategyCode);
        /* string product_group_code = 12; */
        if (message.productGroupCode !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.productGroupCode);
        /* string product_def_code = 13; */
        if (message.productDefCode !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.productDefCode);
        /* string vendor_number = 14; */
        if (message.vendorNumber !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.vendorNumber);
        /* string manufacturer_number = 15; */
        if (message.manufacturerNumber !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.manufacturerNumber);
        /* string brand_name = 16; */
        if (message.brandName !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.brandName);
        /* rd.proto.decimal.Decimal minimum_order_quantity = 17; */
        if (message.minimumOrderQuantity)
            Decimal.internalBinaryWrite(message.minimumOrderQuantity, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal retail_units_quantity = 18; */
        if (message.retailUnitsQuantity)
            Decimal.internalBinaryWrite(message.retailUnitsQuantity, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal retail_unit_dom_quantity = 19; */
        if (message.retailUnitDomQuantity)
            Decimal.internalBinaryWrite(message.retailUnitDomQuantity, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal consumer_unit_quantity = 20; */
        if (message.consumerUnitQuantity)
            Decimal.internalBinaryWrite(message.consumerUnitQuantity, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* string consumer_unit_of_measure_code = 21; */
        if (message.consumerUnitOfMeasureCode !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.consumerUnitOfMeasureCode);
        /* string shelf_sequence = 22; */
        if (message.shelfSequence !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.shelfSequence);
        /* string exp_fmt_disc_flag = 23; */
        if (message.expFmtDiscFlag !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.expFmtDiscFlag);
        /* string conv_fmt_disc_flag = 24; */
        if (message.convFmtDiscFlag !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.convFmtDiscFlag);
        /* string core_fmt_disc_flag = 25; */
        if (message.coreFmtDiscFlag !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.coreFmtDiscFlag);
        /* string super_fmt_disc_flag = 26; */
        if (message.superFmtDiscFlag !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.superFmtDiscFlag);
        /* string plano_other_flag = 27; */
        if (message.planoOtherFlag !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.planoOtherFlag);
        /* rd.proto.decimal.Decimal item_weight_quantity = 28; */
        if (message.itemWeightQuantity)
            Decimal.internalBinaryWrite(message.itemWeightQuantity, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal each_length = 29; */
        if (message.eachLength)
            Decimal.internalBinaryWrite(message.eachLength, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal each_width = 30; */
        if (message.eachWidth)
            Decimal.internalBinaryWrite(message.eachWidth, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal each_height = 31; */
        if (message.eachHeight)
            Decimal.internalBinaryWrite(message.eachHeight, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal each_volume = 32; */
        if (message.eachVolume)
            Decimal.internalBinaryWrite(message.eachVolume, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal case_pack_length = 33; */
        if (message.casePackLength)
            Decimal.internalBinaryWrite(message.casePackLength, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal case_pack_width = 34; */
        if (message.casePackWidth)
            Decimal.internalBinaryWrite(message.casePackWidth, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal case_pack_height = 35; */
        if (message.casePackHeight)
            Decimal.internalBinaryWrite(message.casePackHeight, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal case_pack_weight = 36; */
        if (message.casePackWeight)
            Decimal.internalBinaryWrite(message.casePackWeight, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal case_pack_volume = 37; */
        if (message.casePackVolume)
            Decimal.internalBinaryWrite(message.casePackVolume, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* string item_status_code = 38; */
        if (message.itemStatusCode !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.itemStatusCode);
        /* string change_code = 39; */
        if (message.changeCode !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.changeCode);
        /* string central_warehouse_code = 40; */
        if (message.centralWarehouseCode !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.centralWarehouseCode);
        /* string central_warehouse_change_flag = 41; */
        if (message.centralWarehouseChangeFlag !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.centralWarehouseChangeFlag);
        /* string checklist_page = 42; */
        if (message.checklistPage !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.checklistPage);
        /* string data_type_code = 43; */
        if (message.dataTypeCode !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.dataTypeCode);
        /* string def_goods_code = 44; */
        if (message.defGoodsCode !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.defGoodsCode);
        /* string stock_expire_rec_code = 45; */
        if (message.stockExpireRecCode !== "")
            writer.tag(45, WireType.LengthDelimited).string(message.stockExpireRecCode);
        /* string retrieve_level_department_code = 46; */
        if (message.retrieveLevelDepartmentCode !== "")
            writer.tag(46, WireType.LengthDelimited).string(message.retrieveLevelDepartmentCode);
        /* int32 stock_item_department = 47; */
        if (message.stockItemDepartment !== 0)
            writer.tag(47, WireType.Varint).int32(message.stockItemDepartment);
        /* string replenishable_flag = 48; */
        if (message.replenishableFlag !== "")
            writer.tag(48, WireType.LengthDelimited).string(message.replenishableFlag);
        /* string b2b_flag = 49; */
        if (message.b2BFlag !== "")
            writer.tag(49, WireType.LengthDelimited).string(message.b2BFlag);
        /* string replenishment_stock_number = 50; */
        if (message.replenishmentStockNumber !== "")
            writer.tag(50, WireType.LengthDelimited).string(message.replenishmentStockNumber);
        /* string warranty_regulation_code = 51; */
        if (message.warrantyRegulationCode !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.warrantyRegulationCode);
        /* rd.proto.money.FractionalMoney new_dealer_cost = 52; */
        if (message.newDealerCost)
            FractionalMoney.internalBinaryWrite(message.newDealerCost, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* string new_valid_from_date = 53; */
        if (message.newValidFromDate !== "")
            writer.tag(53, WireType.LengthDelimited).string(message.newValidFromDate);
        /* string url_pic = 54; */
        if (message.urlPic !== "")
            writer.tag(54, WireType.LengthDelimited).string(message.urlPic);
        /* string url_thumb = 55; */
        if (message.urlThumb !== "")
            writer.tag(55, WireType.LengthDelimited).string(message.urlThumb);
        /* string selling_uom = 56; */
        if (message.sellingUom !== "")
            writer.tag(56, WireType.LengthDelimited).string(message.sellingUom);
        /* rd.proto.decimal.Decimal order_multiple_quantity = 57; */
        if (message.orderMultipleQuantity)
            Decimal.internalBinaryWrite(message.orderMultipleQuantity, writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney dealer_cost = 61; */
        if (message.dealerCost)
            FractionalMoney.internalBinaryWrite(message.dealerCost, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.EmeryJensenCatalogItem
 */
export const EmeryJensenCatalogItem = new EmeryJensenCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlishMizeCatalogItem$Type extends MessageType<BlishMizeCatalogItem> {
    constructor() {
        super("rd.catalog.BlishMizeCatalogItem", [
            { no: 1, name: "dealer_retail", kind: "message", T: () => Money },
            { no: 2, name: "catalog_location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vendor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mfg_part_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "fine_line_class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "retail_department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "cost_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "retail_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "stocking_unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "retail_unit_conversion", kind: "message", T: () => Decimal },
            { no: 11, name: "break_sell_pack", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "weight", kind: "message", T: () => Decimal },
            { no: 13, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 14, name: "sell_pack", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<BlishMizeCatalogItem>): BlishMizeCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogLocation = "";
        message.vendorName = "";
        message.mfgPartNumber = "";
        message.fineLineClass = "";
        message.retailDepartment = "";
        message.costUnit = "";
        message.retailUnit = "";
        message.stockingUnitOfMeasure = "";
        message.breakSellPack = "";
        if (value !== undefined)
            reflectionMergePartial<BlishMizeCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BlishMizeCatalogItem): BlishMizeCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money dealer_retail */ 1:
                    message.dealerRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.dealerRetail);
                    break;
                case /* string catalog_location */ 2:
                    message.catalogLocation = reader.string();
                    break;
                case /* string vendor_name */ 3:
                    message.vendorName = reader.string();
                    break;
                case /* string mfg_part_number */ 4:
                    message.mfgPartNumber = reader.string();
                    break;
                case /* string fine_line_class */ 5:
                    message.fineLineClass = reader.string();
                    break;
                case /* string retail_department */ 6:
                    message.retailDepartment = reader.string();
                    break;
                case /* string cost_unit */ 7:
                    message.costUnit = reader.string();
                    break;
                case /* string retail_unit */ 8:
                    message.retailUnit = reader.string();
                    break;
                case /* string stocking_unit_of_measure */ 9:
                    message.stockingUnitOfMeasure = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal retail_unit_conversion */ 10:
                    message.retailUnitConversion = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailUnitConversion);
                    break;
                case /* string break_sell_pack */ 11:
                    message.breakSellPack = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal weight */ 12:
                    message.weight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 13:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.decimal.Decimal sell_pack */ 14:
                    message.sellPack = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.sellPack);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BlishMizeCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money dealer_retail = 1; */
        if (message.dealerRetail)
            Money.internalBinaryWrite(message.dealerRetail, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string catalog_location = 2; */
        if (message.catalogLocation !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.catalogLocation);
        /* string vendor_name = 3; */
        if (message.vendorName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.vendorName);
        /* string mfg_part_number = 4; */
        if (message.mfgPartNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mfgPartNumber);
        /* string fine_line_class = 5; */
        if (message.fineLineClass !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fineLineClass);
        /* string retail_department = 6; */
        if (message.retailDepartment !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.retailDepartment);
        /* string cost_unit = 7; */
        if (message.costUnit !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.costUnit);
        /* string retail_unit = 8; */
        if (message.retailUnit !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.retailUnit);
        /* string stocking_unit_of_measure = 9; */
        if (message.stockingUnitOfMeasure !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.stockingUnitOfMeasure);
        /* rd.proto.decimal.Decimal retail_unit_conversion = 10; */
        if (message.retailUnitConversion)
            Decimal.internalBinaryWrite(message.retailUnitConversion, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string break_sell_pack = 11; */
        if (message.breakSellPack !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.breakSellPack);
        /* rd.proto.decimal.Decimal weight = 12; */
        if (message.weight)
            Decimal.internalBinaryWrite(message.weight, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 13; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal sell_pack = 14; */
        if (message.sellPack)
            Decimal.internalBinaryWrite(message.sellPack, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.BlishMizeCatalogItem
 */
export const BlishMizeCatalogItem = new BlishMizeCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WallaceCatalogItem$Type extends MessageType<WallaceCatalogItem> {
    constructor() {
        super("rd.catalog.WallaceCatalogItem", [
            { no: 1, name: "change_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fineline", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "mfg_vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mfg_part_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "mfg_vendor_cost", kind: "message", T: () => FractionalMoney },
            { no: 8, name: "replacement_cost", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "retail_price", kind: "message", T: () => FractionalMoney },
            { no: 10, name: "std_package", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "standard_package", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "purchase_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "item_weight", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "list_factor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "gtin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "stocking_uom", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WallaceCatalogItem>): WallaceCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.changeId = "";
        message.department = "";
        message.class = "";
        message.fineline = "";
        message.mfgVendor = "";
        message.mfgPartNumber = "";
        message.stdPackage = 0;
        message.standardPackage = 0;
        message.purchaseUom = "";
        message.itemWeight = "";
        message.listFactor = "";
        message.gtin = "";
        message.stockingUom = "";
        if (value !== undefined)
            reflectionMergePartial<WallaceCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WallaceCatalogItem): WallaceCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string change_id */ 1:
                    message.changeId = reader.string();
                    break;
                case /* string department */ 2:
                    message.department = reader.string();
                    break;
                case /* string class */ 3:
                    message.class = reader.string();
                    break;
                case /* string fineline */ 4:
                    message.fineline = reader.string();
                    break;
                case /* string mfg_vendor */ 5:
                    message.mfgVendor = reader.string();
                    break;
                case /* string mfg_part_number */ 6:
                    message.mfgPartNumber = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney mfg_vendor_cost */ 7:
                    message.mfgVendorCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.mfgVendorCost);
                    break;
                case /* rd.proto.money.FractionalMoney replacement_cost */ 8:
                    message.replacementCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.replacementCost);
                    break;
                case /* rd.proto.money.FractionalMoney retail_price */ 9:
                    message.retailPrice = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.retailPrice);
                    break;
                case /* int32 std_package */ 10:
                    message.stdPackage = reader.int32();
                    break;
                case /* int32 standard_package */ 11:
                    message.standardPackage = reader.int32();
                    break;
                case /* string purchase_uom */ 12:
                    message.purchaseUom = reader.string();
                    break;
                case /* string item_weight */ 13:
                    message.itemWeight = reader.string();
                    break;
                case /* string list_factor */ 14:
                    message.listFactor = reader.string();
                    break;
                case /* string gtin */ 15:
                    message.gtin = reader.string();
                    break;
                case /* string stocking_uom */ 16:
                    message.stockingUom = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WallaceCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string change_id = 1; */
        if (message.changeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.changeId);
        /* string department = 2; */
        if (message.department !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.department);
        /* string class = 3; */
        if (message.class !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.class);
        /* string fineline = 4; */
        if (message.fineline !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.fineline);
        /* string mfg_vendor = 5; */
        if (message.mfgVendor !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.mfgVendor);
        /* string mfg_part_number = 6; */
        if (message.mfgPartNumber !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mfgPartNumber);
        /* rd.proto.money.FractionalMoney mfg_vendor_cost = 7; */
        if (message.mfgVendorCost)
            FractionalMoney.internalBinaryWrite(message.mfgVendorCost, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney replacement_cost = 8; */
        if (message.replacementCost)
            FractionalMoney.internalBinaryWrite(message.replacementCost, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney retail_price = 9; */
        if (message.retailPrice)
            FractionalMoney.internalBinaryWrite(message.retailPrice, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* int32 std_package = 10; */
        if (message.stdPackage !== 0)
            writer.tag(10, WireType.Varint).int32(message.stdPackage);
        /* int32 standard_package = 11; */
        if (message.standardPackage !== 0)
            writer.tag(11, WireType.Varint).int32(message.standardPackage);
        /* string purchase_uom = 12; */
        if (message.purchaseUom !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.purchaseUom);
        /* string item_weight = 13; */
        if (message.itemWeight !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.itemWeight);
        /* string list_factor = 14; */
        if (message.listFactor !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.listFactor);
        /* string gtin = 15; */
        if (message.gtin !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.gtin);
        /* string stocking_uom = 16; */
        if (message.stockingUom !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.stockingUom);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.WallaceCatalogItem
 */
export const WallaceCatalogItem = new WallaceCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HouseHassonCatalogItem$Type extends MessageType<HouseHassonCatalogItem> {
    constructor() {
        super("rd.catalog.HouseHassonCatalogItem", [
            { no: 1, name: "ship_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "stock_pack", kind: "message", T: () => Decimal },
            { no: 3, name: "retail_pack", kind: "message", T: () => Decimal },
            { no: 4, name: "department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "weight", kind: "message", T: () => Decimal },
            { no: 6, name: "do_not_break_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "suggested_retail_price", kind: "message", T: () => Money },
            { no: 8, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "discontinued", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<HouseHassonCatalogItem>): HouseHassonCatalogItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shipUnit = "";
        message.department = "";
        message.doNotBreakFlag = "";
        message.discontinued = false;
        if (value !== undefined)
            reflectionMergePartial<HouseHassonCatalogItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HouseHassonCatalogItem): HouseHassonCatalogItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ship_unit */ 1:
                    message.shipUnit = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal stock_pack */ 2:
                    message.stockPack = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.stockPack);
                    break;
                case /* rd.proto.decimal.Decimal retail_pack */ 3:
                    message.retailPack = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailPack);
                    break;
                case /* string department */ 4:
                    message.department = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal weight */ 5:
                    message.weight = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* string do_not_break_flag */ 6:
                    message.doNotBreakFlag = reader.string();
                    break;
                case /* rd.proto.money.Money suggested_retail_price */ 7:
                    message.suggestedRetailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedRetailPrice);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 8:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* bool discontinued */ 9:
                    message.discontinued = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HouseHassonCatalogItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ship_unit = 1; */
        if (message.shipUnit !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.shipUnit);
        /* rd.proto.decimal.Decimal stock_pack = 2; */
        if (message.stockPack)
            Decimal.internalBinaryWrite(message.stockPack, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal retail_pack = 3; */
        if (message.retailPack)
            Decimal.internalBinaryWrite(message.retailPack, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string department = 4; */
        if (message.department !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.department);
        /* rd.proto.decimal.Decimal weight = 5; */
        if (message.weight)
            Decimal.internalBinaryWrite(message.weight, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string do_not_break_flag = 6; */
        if (message.doNotBreakFlag !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.doNotBreakFlag);
        /* rd.proto.money.Money suggested_retail_price = 7; */
        if (message.suggestedRetailPrice)
            Money.internalBinaryWrite(message.suggestedRetailPrice, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 8; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool discontinued = 9; */
        if (message.discontinued !== false)
            writer.tag(9, WireType.Varint).bool(message.discontinued);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.HouseHassonCatalogItem
 */
export const HouseHassonCatalogItem = new HouseHassonCatalogItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SKU$Type extends MessageType<SKU> {
    constructor() {
        super("rd.catalog.SKU", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 4, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "do_it_best_catalog_item", kind: "message", T: () => DoItBestCatalogItem },
            { no: 25, name: "orgill_catalog_item", kind: "message", T: () => OrgillCatalogItem },
            { no: 26, name: "true_value_catalog_item", kind: "message", T: () => TrueValueCatalogItem },
            { no: 28, name: "emery_jensen_catalog_item", kind: "message", T: () => EmeryJensenCatalogItem },
            { no: 29, name: "wallace_catalog_item", kind: "message", T: () => WallaceCatalogItem },
            { no: 30, name: "blish_mize_catalog_item", kind: "message", T: () => BlishMizeCatalogItem },
            { no: 31, name: "house_hasson_catalog_item", kind: "message", T: () => HouseHassonCatalogItem },
            { no: 27, name: "account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "company_id", kind: "message", T: () => UUID },
            { no: 33, name: "visibility", kind: "enum", T: () => ["rd.search.cache.visibility.Visibility", Visibility, "VISIBILITY_"] },
            { no: 34, name: "origin", kind: "enum", T: () => ["rd.catalog.SKU.Origin", SKU_Origin, "ORIGIN_"] }
        ]);
    }
    create(value?: PartialMessage<SKU>): SKU {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vendor = 0;
        message.sku = "";
        message.upc = "";
        message.description = "";
        message.accountNumber = "";
        message.visibility = 0;
        message.origin = 0;
        if (value !== undefined)
            reflectionMergePartial<SKU>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SKU): SKU {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor vendor */ 3:
                    message.vendor = reader.int32();
                    break;
                case /* string sku */ 4:
                    message.sku = reader.string();
                    break;
                case /* string upc */ 14:
                    message.upc = reader.string();
                    break;
                case /* string description */ 9:
                    message.description = reader.string();
                    break;
                case /* rd.catalog.DoItBestCatalogItem do_it_best_catalog_item */ 24:
                    message.doItBestCatalogItem = DoItBestCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.doItBestCatalogItem);
                    break;
                case /* rd.catalog.OrgillCatalogItem orgill_catalog_item */ 25:
                    message.orgillCatalogItem = OrgillCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.orgillCatalogItem);
                    break;
                case /* rd.catalog.TrueValueCatalogItem true_value_catalog_item */ 26:
                    message.trueValueCatalogItem = TrueValueCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.trueValueCatalogItem);
                    break;
                case /* rd.catalog.EmeryJensenCatalogItem emery_jensen_catalog_item */ 28:
                    message.emeryJensenCatalogItem = EmeryJensenCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.emeryJensenCatalogItem);
                    break;
                case /* rd.catalog.WallaceCatalogItem wallace_catalog_item */ 29:
                    message.wallaceCatalogItem = WallaceCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.wallaceCatalogItem);
                    break;
                case /* rd.catalog.BlishMizeCatalogItem blish_mize_catalog_item */ 30:
                    message.blishMizeCatalogItem = BlishMizeCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.blishMizeCatalogItem);
                    break;
                case /* rd.catalog.HouseHassonCatalogItem house_hasson_catalog_item */ 31:
                    message.houseHassonCatalogItem = HouseHassonCatalogItem.internalBinaryRead(reader, reader.uint32(), options, message.houseHassonCatalogItem);
                    break;
                case /* string account_number */ 27:
                    message.accountNumber = reader.string();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 32:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.search.cache.visibility.Visibility visibility */ 33:
                    message.visibility = reader.int32();
                    break;
                case /* rd.catalog.SKU.Origin origin */ 34:
                    message.origin = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SKU, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.integration_vendor.IntegrationVendor vendor = 3; */
        if (message.vendor !== 0)
            writer.tag(3, WireType.Varint).int32(message.vendor);
        /* string sku = 4; */
        if (message.sku !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sku);
        /* string description = 9; */
        if (message.description !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.description);
        /* string upc = 14; */
        if (message.upc !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.upc);
        /* rd.catalog.DoItBestCatalogItem do_it_best_catalog_item = 24; */
        if (message.doItBestCatalogItem)
            DoItBestCatalogItem.internalBinaryWrite(message.doItBestCatalogItem, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.OrgillCatalogItem orgill_catalog_item = 25; */
        if (message.orgillCatalogItem)
            OrgillCatalogItem.internalBinaryWrite(message.orgillCatalogItem, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.TrueValueCatalogItem true_value_catalog_item = 26; */
        if (message.trueValueCatalogItem)
            TrueValueCatalogItem.internalBinaryWrite(message.trueValueCatalogItem, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* string account_number = 27; */
        if (message.accountNumber !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.accountNumber);
        /* rd.catalog.EmeryJensenCatalogItem emery_jensen_catalog_item = 28; */
        if (message.emeryJensenCatalogItem)
            EmeryJensenCatalogItem.internalBinaryWrite(message.emeryJensenCatalogItem, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.WallaceCatalogItem wallace_catalog_item = 29; */
        if (message.wallaceCatalogItem)
            WallaceCatalogItem.internalBinaryWrite(message.wallaceCatalogItem, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.BlishMizeCatalogItem blish_mize_catalog_item = 30; */
        if (message.blishMizeCatalogItem)
            BlishMizeCatalogItem.internalBinaryWrite(message.blishMizeCatalogItem, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.HouseHassonCatalogItem house_hasson_catalog_item = 31; */
        if (message.houseHassonCatalogItem)
            HouseHassonCatalogItem.internalBinaryWrite(message.houseHassonCatalogItem, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 32; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.cache.visibility.Visibility visibility = 33; */
        if (message.visibility !== 0)
            writer.tag(33, WireType.Varint).int32(message.visibility);
        /* rd.catalog.SKU.Origin origin = 34; */
        if (message.origin !== 0)
            writer.tag(34, WireType.Varint).int32(message.origin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.SKU
 */
export const SKU = new SKU$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrgillWarehouseItem$Type extends MessageType<OrgillWarehouseItem> {
    constructor() {
        super("rd.catalog.OrgillWarehouseItem", [
            { no: 1, name: "inventory", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "velocity_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "replacement_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "substitute_item", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "min_purchase_multiple", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "shelf_pack", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "quantity_round_option", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrgillWarehouseItem>): OrgillWarehouseItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inventory = 0;
        message.velocityCode = "";
        message.replacementItem = "";
        message.substituteItem = "";
        message.minPurchaseMultiple = 0;
        message.shelfPack = 0;
        message.quantityRoundOption = "";
        if (value !== undefined)
            reflectionMergePartial<OrgillWarehouseItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrgillWarehouseItem): OrgillWarehouseItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 inventory */ 1:
                    message.inventory = reader.int32();
                    break;
                case /* string velocity_code */ 2:
                    message.velocityCode = reader.string();
                    break;
                case /* string replacement_item */ 3:
                    message.replacementItem = reader.string();
                    break;
                case /* string substitute_item */ 4:
                    message.substituteItem = reader.string();
                    break;
                case /* int32 min_purchase_multiple */ 5:
                    message.minPurchaseMultiple = reader.int32();
                    break;
                case /* int32 shelf_pack */ 6:
                    message.shelfPack = reader.int32();
                    break;
                case /* string quantity_round_option */ 7:
                    message.quantityRoundOption = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrgillWarehouseItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 inventory = 1; */
        if (message.inventory !== 0)
            writer.tag(1, WireType.Varint).int32(message.inventory);
        /* string velocity_code = 2; */
        if (message.velocityCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.velocityCode);
        /* string replacement_item = 3; */
        if (message.replacementItem !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.replacementItem);
        /* string substitute_item = 4; */
        if (message.substituteItem !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.substituteItem);
        /* int32 min_purchase_multiple = 5; */
        if (message.minPurchaseMultiple !== 0)
            writer.tag(5, WireType.Varint).int32(message.minPurchaseMultiple);
        /* int32 shelf_pack = 6; */
        if (message.shelfPack !== 0)
            writer.tag(6, WireType.Varint).int32(message.shelfPack);
        /* string quantity_round_option = 7; */
        if (message.quantityRoundOption !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.quantityRoundOption);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.OrgillWarehouseItem
 */
export const OrgillWarehouseItem = new OrgillWarehouseItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DoItBestWarehouseItem$Type extends MessageType<DoItBestWarehouseItem> {
    constructor() {
        super("rd.catalog.DoItBestWarehouseItem", [
            { no: 1, name: "inventory", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "product_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "estimated_in_stock_date", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<DoItBestWarehouseItem>): DoItBestWarehouseItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inventory = 0;
        message.productCode = "";
        if (value !== undefined)
            reflectionMergePartial<DoItBestWarehouseItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DoItBestWarehouseItem): DoItBestWarehouseItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 inventory */ 1:
                    message.inventory = reader.int32();
                    break;
                case /* string product_code */ 2:
                    message.productCode = reader.string();
                    break;
                case /* google.protobuf.Timestamp estimated_in_stock_date */ 3:
                    message.estimatedInStockDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.estimatedInStockDate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DoItBestWarehouseItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 inventory = 1; */
        if (message.inventory !== 0)
            writer.tag(1, WireType.Varint).int32(message.inventory);
        /* string product_code = 2; */
        if (message.productCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.productCode);
        /* google.protobuf.Timestamp estimated_in_stock_date = 3; */
        if (message.estimatedInStockDate)
            Timestamp.internalBinaryWrite(message.estimatedInStockDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.DoItBestWarehouseItem
 */
export const DoItBestWarehouseItem = new DoItBestWarehouseItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TrueValueWarehouseItem$Type extends MessageType<TrueValueWarehouseItem> {
    constructor() {
        super("rd.catalog.TrueValueWarehouseItem", [
            { no: 1, name: "inventory", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<TrueValueWarehouseItem>): TrueValueWarehouseItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inventory = 0;
        if (value !== undefined)
            reflectionMergePartial<TrueValueWarehouseItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TrueValueWarehouseItem): TrueValueWarehouseItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 inventory */ 1:
                    message.inventory = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TrueValueWarehouseItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 inventory = 1; */
        if (message.inventory !== 0)
            writer.tag(1, WireType.Varint).int32(message.inventory);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.TrueValueWarehouseItem
 */
export const TrueValueWarehouseItem = new TrueValueWarehouseItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmeryJensenWarehouseItem$Type extends MessageType<EmeryJensenWarehouseItem> {
    constructor() {
        super("rd.catalog.EmeryJensenWarehouseItem", [
            { no: 1, name: "inventory", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<EmeryJensenWarehouseItem>): EmeryJensenWarehouseItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inventory = 0;
        if (value !== undefined)
            reflectionMergePartial<EmeryJensenWarehouseItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmeryJensenWarehouseItem): EmeryJensenWarehouseItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 inventory */ 1:
                    message.inventory = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmeryJensenWarehouseItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 inventory = 1; */
        if (message.inventory !== 0)
            writer.tag(1, WireType.Varint).int32(message.inventory);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.EmeryJensenWarehouseItem
 */
export const EmeryJensenWarehouseItem = new EmeryJensenWarehouseItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WarehouseInfo$Type extends MessageType<WarehouseInfo> {
    constructor() {
        super("rd.catalog.WarehouseInfo", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 5, name: "warehouse_location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "orgill_warehouse_item", kind: "message", T: () => OrgillWarehouseItem },
            { no: 9, name: "do_it_best_warehouse_item", kind: "message", T: () => DoItBestWarehouseItem },
            { no: 10, name: "true_value_warehouse_item", kind: "message", T: () => TrueValueWarehouseItem },
            { no: 11, name: "emery_jensen_warehouse_item", kind: "message", T: () => EmeryJensenWarehouseItem },
            { no: 12, name: "company_id", kind: "message", T: () => UUID },
            { no: 33, name: "visibility", kind: "enum", T: () => ["rd.search.cache.visibility.Visibility", Visibility, "VISIBILITY_"] }
        ]);
    }
    create(value?: PartialMessage<WarehouseInfo>): WarehouseInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vendor = 0;
        message.warehouseLocation = "";
        message.sku = "";
        message.accountNumber = "";
        message.visibility = 0;
        if (value !== undefined)
            reflectionMergePartial<WarehouseInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WarehouseInfo): WarehouseInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor vendor */ 4:
                    message.vendor = reader.int32();
                    break;
                case /* string warehouse_location */ 5:
                    message.warehouseLocation = reader.string();
                    break;
                case /* string sku */ 6:
                    message.sku = reader.string();
                    break;
                case /* string account_number */ 7:
                    message.accountNumber = reader.string();
                    break;
                case /* rd.catalog.OrgillWarehouseItem orgill_warehouse_item */ 8:
                    message.orgillWarehouseItem = OrgillWarehouseItem.internalBinaryRead(reader, reader.uint32(), options, message.orgillWarehouseItem);
                    break;
                case /* rd.catalog.DoItBestWarehouseItem do_it_best_warehouse_item */ 9:
                    message.doItBestWarehouseItem = DoItBestWarehouseItem.internalBinaryRead(reader, reader.uint32(), options, message.doItBestWarehouseItem);
                    break;
                case /* rd.catalog.TrueValueWarehouseItem true_value_warehouse_item */ 10:
                    message.trueValueWarehouseItem = TrueValueWarehouseItem.internalBinaryRead(reader, reader.uint32(), options, message.trueValueWarehouseItem);
                    break;
                case /* rd.catalog.EmeryJensenWarehouseItem emery_jensen_warehouse_item */ 11:
                    message.emeryJensenWarehouseItem = EmeryJensenWarehouseItem.internalBinaryRead(reader, reader.uint32(), options, message.emeryJensenWarehouseItem);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 12:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.search.cache.visibility.Visibility visibility */ 33:
                    message.visibility = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WarehouseInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.integration_vendor.IntegrationVendor vendor = 4; */
        if (message.vendor !== 0)
            writer.tag(4, WireType.Varint).int32(message.vendor);
        /* string warehouse_location = 5; */
        if (message.warehouseLocation !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.warehouseLocation);
        /* string sku = 6; */
        if (message.sku !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.sku);
        /* string account_number = 7; */
        if (message.accountNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.accountNumber);
        /* rd.catalog.OrgillWarehouseItem orgill_warehouse_item = 8; */
        if (message.orgillWarehouseItem)
            OrgillWarehouseItem.internalBinaryWrite(message.orgillWarehouseItem, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.DoItBestWarehouseItem do_it_best_warehouse_item = 9; */
        if (message.doItBestWarehouseItem)
            DoItBestWarehouseItem.internalBinaryWrite(message.doItBestWarehouseItem, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.TrueValueWarehouseItem true_value_warehouse_item = 10; */
        if (message.trueValueWarehouseItem)
            TrueValueWarehouseItem.internalBinaryWrite(message.trueValueWarehouseItem, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.EmeryJensenWarehouseItem emery_jensen_warehouse_item = 11; */
        if (message.emeryJensenWarehouseItem)
            EmeryJensenWarehouseItem.internalBinaryWrite(message.emeryJensenWarehouseItem, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 12; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.cache.visibility.Visibility visibility = 33; */
        if (message.visibility !== 0)
            writer.tag(33, WireType.Varint).int32(message.visibility);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.catalog.WarehouseInfo
 */
export const WarehouseInfo = new WarehouseInfo$Type();
